// th_TH.js
import React from "react";
const th_TH = {
    "ZiZhangHao":"บัญชีย่อย",

    "ZHONGWEN":"Chinese",
    "YINGYU":"English",
    "XIBANYAYU":"Español",
    "DEYU":"Deutsch",
    "FAYU":"Français",
    "ALABOYU":"العربية",
    "EYU":"Русский",
    "MALAIYU":"Bahasa Malaysia",
    "YUENANYU":"Tiếng Việt",
    "TAIYU":"ภาษาไทย",
    "YINNIYU":"Bahasa Indonesia",
    // ส่วนประกอบหลัก
    "XiaDanTiXing": "แจ้งเตือนคำสั่งซื้อ",
    "NH_GDDBH_": "คำสั่งซื้อนี้มีสินค้าราคาประมาณ ต้องรอการยืนยันจากลูกค้าก่อนชำระเงิน ยืนยันคำสั่งซื้อหรือไม่?",
    "QueRenXiaDan": "ยืนยันคำสั่งซื้อ",
    "WoZaiKanKan": "ดูทีหลัง",
    "XSQBDZ": "แสดงที่อยู่ทั้งหมด",
    // ห้องแชท
    "ZBZCBQFH": "ไม่รองรับอีโมจิ",
    "FaSongLianJie": "ส่งลิงก์",
    "YiChangXiaoXi": "ข้อความผิดพลาด",
    "QingShuRu": "กรุณาใส่",
    "FaSong": "ส่ง",
    // ตัวเลือกวันที่
    "DQSJXYKSSJ": "เวลาปัจจุบันเร็วกว่าเวลาเริ่มต้น",
    "DQSJCGJSSJ": "เวลาปัจจุบันเลยเวลาสิ้นสุด",
    "QuXiao": "ยกเลิก",
    "NianYueRi": "ปี-เดือน-วัน",
    "ShiFen": "ชั่วโมง-นาที",
    "QueDing": "ตกลง",
    "Nian": "ปี",
    "Yue": "เดือน",
    "Ri": "วัน",
    "Shi": "ชั่วโมง",
    "Fen": "นาที",
    // การ์ดรายการสินค้า
    "Qi": "เริ่มที่",
    // โปรโมชั่นสินค้า
    "1GeCuXiao": "1 โปรโมชั่น",
    "ChaKanZengPin": "ดูของแถม",
    "JHDJSHS_1T": "โปรโมชั่นสิ้นสุดใน: {d} วัน {h} ชม. {m} นาที {s} วินาที",
    "YHGZ_ZPBKD": "กฎ: ของแถมไม่สะสม",
    "YHGZ_AZZGM": "กฎ: ส่วนลดตามจำนวนที่ซื้อ",
    "GuanBi": "ปิด",
    // ตัวกรองกลุ่ม
    "QuanBu": "ทั้งหมด",
    "ZWXGSJ": "ไม่มีข้อมูล",
    "ZuiDiJia": "ราคาต่ำสุด",
    "ZuiGaoJia": "ราคาสูงสุด",
    "LeiXing": "ประเภท",
    "PinPai": "แบรนด์",
    "BiaoQian": "แท็ก",
    "JiaGeQuJian": "ช่วงราคา",
    "SPMC_GG_BH_": "ชื่อ / รุ่น / เลขที่",
    "ZuHeShaiXuan": "ตัวกรองรวม",
    "ChongZhi_CanShu": "รีเซ็ต",
    // อัปโหลดรูปภาพ
    "ZDKSC1ZTP": "สูงสุด {num} รูป",
    "ZYXSCTP": "เฉพาะรูปภาพเท่านั้น",
    "SCTPDXBYXC": "ขนาดรูปไม่เกิน {size}",
    "QBYCFSCTP_": "ห้ามอัปโหลดรูปซ้ำ",
    "ShangChuanChengGong": "อัปโหลดสำเร็จ",
    "ZDKSC1Z": "สูงสุด {num}",
    // คีย์บอร์ด
    "CCSLZDXZ": "เกินจำนวนสูงสุด",
    "QiDingLiang": "ขั้นต่ำต่อออร์เดอร์",
    "ShouQi": "ปิด",
    "ShanChu": "ลบ",
    // คำสั่งซื้อ
    "Dai": "รอ",
    "YiQuXiao": "ยกเลิกแล้ว",
    "ZengPin": "ของแถม",
    "1Zhong": "{num} ประเภท",
    "1Jian": "1 ชิ้น",
    "HeJi": "รวม",
    "DaiFu": "รอชำระ",
    // อื่นๆ
    "_DDM1YZ1J_": "[สั่งซื้อ {targetPrice}฿ แถม {presentNum} ชิ้น]",
    "_DDM1YLJ1Y_": "[สั่งซื้อ {targetPrice}฿ ลด {price}฿]",
    "_DDM1YLX1Z_": "[สั่งซื้อ {targetPrice}฿ ส่วนลด {discount}%]",
    "DingDanCuXiao": "โปรโมชั่นคำสั่งซื้อ",
    "DLCKJG": "เข้าสู่ระบบเพื่อดูราคา",
    "DianPuZhuYe": "หน้าหลักร้านค้า",
    "GouWuChe": "ตะกร้า",
    "ZaiXianKeFu": "บริการลูกค้า",
    "GeRenZhongXin": "โปรไฟล์ฉัน",
    "LianXiDianHua": "โทรศัพท์",
    "FanHuiDingBu": "กลับด้านบน",
    "ZBDYML": "ไม่พบหน้า",
    "KNWZCW_HZY": "ลิงก์ผิดหรือหน้าถูกลบ",
    "FanHuiShangJi": "ย้อนกลับ",
    "FanHuiShouYe": "กลับหน้าหลัก",
    "SFQRSCSP": "ลบสินค้าหรือไม่?",
    "QueRen": "ยืนยัน",
    "YiChuShangPin": "นำออก",
    "XiuGai": "แก้ไข",
    "DaiQueRen": "รอยืนยัน",
    "DaiFaHuo": "รอจัดส่ง",
    "DaiShouHuo": "รอรับสินค้า",
    "YiWanCheng": "เสร็จสิ้น",
    "YiZuoFei": "ยกเลิกแล้ว",
    "DaiShenHe": "รอตรวจสอบ",
    "DaiHeXiao": "รอรับรอง",
    "YiHeXiao": "รับรองแล้ว",
    "XianXiaZhiFu": "ชำระเงินออฟไลน์",
    "ZhiNengDaoZhangShiBie": "โอนเงิน (ยืนยันอัตโนมัติ)",
    "WeiXinZhiFu": "WeChat Pay",
    "KqZhiFu": "Kuaiqian Pay (WeChat/Alipay)",
    "ZFBZF": "Alipay",
    "YuEZhiFu": "ยอดคงเหลือ",
    "HuoDaoFuKuan": "เก็บเงินปลายทาง",
    "DaiTuiHuo": "รอคืนสินค้า",
    "DaiTuiKuan": "รอคืนเงิน",
    "ChuangJianDingDan": "สร้างคำสั่งซื้อ",
    "BianJiDingDan": "แก้ไขคำสั่งซื้อ",
    "TiJiaoDingDan": "ส่งคำสั่งซื้อ",
    "DingDanShenHe": "ตรวจสอบคำสั่งซื้อ",
    "CaiWuShenHe": "ตรวจสอบการเงิน",
    "BoHui": "ปฏิเสธ",
    "TianJiaShouKuan": "เพิ่มการชำระ",
    "ZaiXianZhiFu": "ชำระออนไลน์ (WeChat/Alipay/JD Pay/UnionPay)",
    "YinLianZhiFu": "UnionPay",
    "MercadoPagoZhiFu": "Mercado Pago",
    "ShouKuanShenHe": "ตรวจสอบการชำระ",
    "ShouKuanZuoFei": "ยกเลิกการชำระ",
    "ChuKu": "ออกจากคลัง",
    "ChuKuShenHe": "ตรวจสอบการออกคลัง",
    "FaHuo": "จัดส่ง",
    "TianJiaWuLiu": "เพิ่มเลขติดตาม",
    "XiuGaiWuLiu": "แก้ไขเลขติดตาม",
    "ChuKuZuoFei": "ยกเลิกการออกคลัง",
    "ShouHuo": "รับสินค้า",
    "DingDanHeZhun": "อนุมัติคำสั่งซื้อ",
    "QuXiaoDingDan": "ยกเลิกคำสั่งซื้อ",
    "CJTHD": "สร้างใบคืน",
    "DaYin": "พิมพ์",
    "DaoChu": "ส่งออก",
    "DingDanWanCheng": "คำสั่งซื้อเสร็จสิ้น",
    "QiangZhiWanCheng": "เสร็จสิ้นแบบบังคับ",
    "DingDanZuoFei": "ยกเลิกคำสั่งซื้อ",
    "MaiZeng": "ซื้อแถมฟรี",
    "ZhiJiang": "ลดทันที",
    "DaZhe": "ส่วนลด %",
    "YuShou": "พรีออเดอร์",
    "DingDanManZeng": "แถมฟรีเมื่อสั่งซื้อครบ",
    "DingDanManJian": "ลดทันทีเมื่อสั่งซื้อครบ",
    "DingDanManZhe": "ส่วนลดเมื่อสั่งซื้อครบ",
    "XinRenQuan": "คูปองสมาชิกใหม่",
    "ManJianQuan": "คูปองลดเมื่อครบ",
    "ShangPinQuan": "คูปองสินค้า",
    "DaiJieSuan": "รอการชำระ",
    "YiJieSuan": "ชำระแล้ว",
    "QuanBuShangPin": "สินค้าทั้งหมด",
    "TuiJianShangPin": "แนะนำ",
    "XinPin": "มาใหม่",
    "ReXiaoShangPin": "ขายดี",
    "ChangYongShangPin": "ซื้อบ่อย",
    "DaiShouKuan": "รอการชำระ",
    "BuFenShouKuan": "ชำระบางส่วน",
    "YiShouKuan": "ชำระแล้ว",
    "BXYFP": "ไม่ต้องใบกำกับ",
    "ZZSPTFP": "ใบกำกับภาษีทั่วไป",
    "ZZSZYFP": "ใบกำกับภาษีเฉพาะ",
    "QiTaFaPiao": "ใบกำกับอื่น",
    "XianXia": "ออฟไลน์",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "เงินฝาก",
    "XianXiaZhuangZhang": "โอนเงิน",
    "XianShangZhiFu": "ชำระออนไลน์",
    "YCKZF": "ชำระด้วยยอดคงเหลือ",
    "DaiTiJiao": "รอส่ง",
    "KuaiDi": "จัดส่งด่วน",
    "SongHuoShangMen": "จัดส่งถึงบ้าน",
    "ShangMenZiQu": "รับด้วยตนเอง",
    "WuLiuHuoYun": "ขนส่งสินค้า",
    "QiTa": "อื่นๆ",
    "YouHuo": "มีสต็อก",
    "WuHuo": "ไม่มีสต็อก",
    "SJCW_QLXKF": "ข้อมูลผิดพลาด ติดต่อฝ่ายสนับสนุน",
    "ShangJia": "วางจำหน่าย",
    "YiXiaJia": "ยกเลิกจำหน่าย",
    "YiJinYong": "ปิดการใช้งาน",
    "YiQiYong": "เปิดการใช้งาน",
    "YiTingYong": "ระงับ",
    "KeHuZhuCe": "ลงทะเบียนลูกค้า",
    "XinZengDaoRu": "นำเข้า",
    "DDDSH": "รอตรวจสอบ",
    "DCWSH": "รอตรวจสอบการเงิน",
    "DaiChuKu": "รอออกคลัง",
    "DCK_BF_": "รอออกคลัง (บางส่วน)",
    "DFH_BF_": "รอจัดส่ง (บางส่วน)",
    "DSH_BF_": "รอรับสินค้า (บางส่วน)",
    "DSK_BF_": "รอชำระ (บางส่วน)",
    "WTHSQ": "ไม่มีคำขอยกเลิก",
    "THDSH": "รอตรวจสอบการคืน",
    "THCLZ": "กำลังดำเนินการคืน",
    "THYWC": "คืนสินค้าเสร็จสิ้น",
    "DYDHD": "พิมพ์คำสั่งซื้อ",
    "DYFHD": "พิมพ์ใบส่งของ",
    "DCDHD": "ส่งออกคำสั่งซื้อ",
    "DCFHDWE_P": "ส่งออกเป็น Excel/PDF",
    "TuiDanZuoFei": "ยกเลิกการคืน",
    "DTHSH": "รอตรวจสอบการคืน",
    "DaiRuKu": "รอเข้ารับ",
    "DRK_BF_": "รอเข้ารับ (บางส่วน)",
    "DFK_BF_": "รอชำระ (บางส่วน)",
    "ChuangJianTuiDan": "สร้างใบคืน",
    "BianJiTuiDan": "แก้ไขใบคืน",
    "TiJiaoTuiDan": "ส่งใบคืน",
    "TuiHuoShenHe": "ตรวจสอบการคืน",
    "RuKu": "เข้ารับ",
    "RuKuShenHe": "ตรวจสอบการเข้ารับ",
    "RuKuZuoFei": "ยกเลิกการเข้ารับ",
    "TianJiaFuKuan": "เพิ่มการชำระ",
    "FuKuanZuoFei": "ยกเลิกการชำระ",
    "FuKuanShenHe": "ตรวจสอบการชำระ",
    "TuiDanWanCheng": "การคืนเสร็จสิ้น",
    "QiTaChuKu": "ออกคลังอื่น",
    "XiaoShouChuKu": "ออกคลังขาย",
    "PanKuiChuKu": "ออกคลังขาด",
    "DiaoBoChuKu": "โอนออก",
    "CaiGouTuiHuo": "คืนซัพพลายเออร์",
    "TuiHuoRuKu": "เข้ารับคืน",
    "CaiGouRuKu": "เข้ารับซื้อ",
    "QiTaRuKu": "เข้ารับอื่น",
    "PanYingRuKu": "เข้ารับเกิน",
    "DiaoBoRuKu": "โอนเข้า",
    "CJCGD": "สร้างคำสั่งซื้อ",
    "BJCGD": "แก้ไขคำสั่งซื้อ",
    "TJCGD": "ส่งคำสั่งซื้อ",
    "CGDZF": "ยกเลิกคำสั่งซื้อ",
    "CGDWC": "การซื้อเสร็จสิ้น",
    "CGTHZF": "ยกเลิกการคืน",
    "CGTHWC": "การคืนเสร็จสิ้น",
    "THDDY": "พิมพ์ใบคืน",
    "THDDC": "ส่งออกใบคืน",
    "CKDDY": "พิมพ์ใบออก",
    "CKDDC": "ส่งออกใบออก",
    "GLDZH": "บัญชีผู้ดูแล",
    "DHDZH": "บัญชีสั่งซื้อ",
    "ShenHeTongGuo": "ผ่านการตรวจสอบ",
    "SHBTG": "ไม่ผ่านการตรวจสอบ",
    "WuXuFaPiao": "ไม่ต้องใบกำกับ",
    "DaiKeXiaDan": "สั่งซื้อแทนลูกค้า",
    "ZiZhuXiaDan": "สั่งซื้อเอง",
    "PCShangCheng": "ร้านค้า PC",
    "APPShangCheng": "ร้านค้าแอป",
    "TVShangCheng": "ร้านค้า TV",
    "WeiXinShangCheng": "ร้านค้า WeChat",
    "ShouJiShangCheng": "ร้านค้ามือถือ",
    "ADDXSMLTC": "คอมมิชชั่นกำไร",
    "ADDXSSRTC": "คอมมิชชั่นรายได้",
    "AKHSSYG": "ตามลูกค้าที่เชื่อมโยง",
    "AnZhiDanRen": "ตามผู้สร้าง",
    "ATHJEBLKCT": "หักคอมมิชชั่นตามมูลค่าคืน",
    "DDYTHBJXTC": "ไม่มีคอมมิชชั่นเมื่อคืน",
    "DaiDaKuan": "รอการโอน",
    "WeiKaiShi": "ยังไม่เริ่ม",
    "JinXingZhong": "กำลังดำเนินการ",
    "YiGuoQi": "หมดอายุ",
    "Yi": "ล้าน",
    "QianWan": "สิบล้าน",
    "BaiWan": "ล้าน",
    "Wan": "หมื่น",
    "Sheng1Tian": "เหลือ 1 วัน",
    "Sheng1XiaoShi": "เหลือ 1 ชม.",
    "Miao": "วิ",
    "1Miao": "1 วิ",
    "GangGang": "เมื่อกี้",
    "1FenZhongQian": "1 นาทีที่แล้ว",
    "1XiaoShiQian": "1 ชม.ที่แล้ว",
    "1TianQian": "1 วันที่แล้ว",
    "1GeYueQian": "1 เดือนที่แล้ว",
    "1NianQian": "1 ปีที่แล้ว",
    "WeiZhiLeiXing": "ประเภทไม่รู้จัก",
    "YYGBCDSP_K": "สินค้าดี! ดูเลย",
    "ZanWeiSheZhi": "ยังไม่ตั้งค่า",
    "HQWXSQXX": "รับข้อมูล WeChat",
    "JGJYYDMBQ": "ปรับขนาดตาม meta tag",
    "NLJZZ": "กำลังโหลด...",
    "ShangPinMingXi": "รายละเอียดสินค้า",
    "ShangPinLeiBie": "หมวดหมู่",
    "QXZFPNR": "เลือกเนื้อหาใบกำกับ",
    "QXZFPLX": "เลือกประเภทใบกำกับ",
    "QTXFPTT": "กรอกชื่อใบกำกับ",
    "FaPiaoTaiTou": "ชื่อใบกำกับ",
    "NSRSBH": "เลขผู้เสียภาษี",
    "FaPiaoNeiRong": "เนื้อหาใบกำกับ",
    "FaPiaoXinXi": "ข้อมูลใบกำกับ",
    "KaiJuFaPiao": "ออกใบกำกับ",
    "FaPiaoLeiXing": "ประเภทใบกำกับ",
    "Han": "รวม",
    "WeiHan": "ไม่รวม",
    "Shui": "ภาษี",
    "QSRFPTT": "กรอกชื่อใบกำกับ",
    "QSRNSRSBH": "กรอกเลขผู้เสียภาษี",
    "YiManZu_Man": "ตรงตามเงื่อนไข: [ครบ",
    "ZaiGou": "ซื้อเพิ่ม",
    "YMZ_DHJJZ": "ตรงตามเงื่อนไข: [ราคาเริ่ม",
    "JianJiangZhi": "ชิ้นในราคา",
    "YMZ_YDHJD": "ตรงตามเงื่อนไข: [ส่วนลด",
    "JianMeiJian": "ชิ้นละ",
    "SYTCSLW0_WFJRGWC": "ไม่มีเซ็ต ไม่สามารถเพิ่มลงตะกร้า",
    "QingXuanXeShangPin": "เลือกสินค้า!",
    "GSPYXJ": "สินค้าหมดจำหน่าย!",
    "ZJ2TN": "2 วันที่แล้ว",
    "QDQCXJSP": "ลบสินค้าหมดจำหน่าย?",
    "QingChuChengGong": "ล้างสำเร็จ",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "เซ็ตไม่สามารถเพิ่มลงตะกร้าได้ ลบเซ็ตก่อน",
    "SPSLBN": "จำนวนสินค้าไม่สามารถ",
    "TaoCanHan": "รวม",
    "TaoCan": "เซ็ต",
    "QHDSL": "ตรวจสอบจำนวน",
    "SPSLBNDY": "จำนวนสินค้าไม่ต่ำกว่า",
    "XianDingLiang": "จำกัด",
    "YiRuShouCang": "เพิ่มรายการโปรด",
    "QuanXuan": "เลือกทั้งหมด",
    "JianZeng": "ชิ้นแถมฟรี",
    "JianLiXiang_Man": "ชิ้น [ครบ",
    "Yuan_": "฿]",
    "Zhe_": "%]",
    "KCBZ_WFJRGWC": "ไม่มีสต็อก ไม่สามารถเพิ่ม",
    "XDJEDYDY": "ยอดสั่งซื้อเกิน",
    "WYXJHYSXDSP": "ไม่มีสินค้าหมดหรือหมดอายุ",
    "DYQDL": "ต่ำกว่าขั้นต่ำ",
    "ZSPG1J": "{count} ประเภท, {number} ชิ้น",
    "WanCheng": "เสร็จ",
    "BianJi": "แก้ไข",
    "You": "มี",
    "ZSPBFHYQ_W": "ประเภทสินค้าไม่ตรงตามเงื่อนไข คลิกดู",
    "SPSLBNGY": "จำนวนสินค้าไม่เกิน",
    "JXDJ_CKXYGBFHYQSP": "คลิกอีกครั้งสำหรับสินค้าถัดไป",
    "XiaDan": "สั่งซื้อ",
    "JianJiang": "ชิ้นลด",
    "QRYCSP": "ลบสินค้าหรือไม่?",
    "QXZXDSP": "เลือกสินค้าสำหรับสั่งซื้อ",
    "KCBZ_QCXXZ": "ไม่มีสต็อก เลือกใหม่!",
    "KuCun": "สต็อก",
    "YCKXD": "฿ ในการสั่งซื้อ",
    "QDSCSP": "เพิ่มรายการโปรด?",
    "ShouCangChengGong": "เพิ่มรายการโปรดสำเร็จ",
    "GYXDL": "เกินจำกัด",
    "LiSheng": "ประหยัด",
    "GWCHSKD_QGYGB": "ตะกร้าว่าง เริ่มช้อป!",
    "QuGuangGuang": "ช้อปเลย",
    "QCXJSP": "ลบสินค้าหมด",
    "ZongE": "รวม",
    "YouHui": "ส่วนลด",
    "QXZJHRQ": "เลือกวันที่จัดส่ง",
    "FuJiaFeiYong": "ค่าบริการเพิ่ม",
    "ZhongShangPin_Gong": "ประเภท, รวม",
    "PeiSongShiJian": "เวลาจัดส่ง",
    "QXZPSSJ": "เลือกเวลาจัดส่ง",
    "DingDanJinE": "ยอดคำสั่งซื้อ",
    "SCFJ_ZD4Z": "อัปโหลดไฟล์ (สูงสุด {num}, แต่ละไฟล์ < {size})",
    "KeYongShangPin": "สินค้าพร้อมจำหน่าย",
    "ShiYongShuoMing": "คำแนะนำ",
    "YouXiaoQi": "อายุการใช้งาน",
    "Man": "ครบ",
    "BZZBZCTSFH": "หมายเหตุ: ไม่รองรับอักขระพิเศษ",
    "QingXuanZe": "เลือก",
    "KaiPiaoXuJia": "ค่าธรรมเนียมใบกำกับ",
    "PeiSongFangShi": "วิธีจัดส่ง",
    "ShangPinZongJia": "ยอดสินค้า",
    "YouHuiQuan": "คูปอง",
    "ZhangKeXan": "ใช้ได้",
    "DDJEWMZ": "ยอดสั่งซื้อไม่ถึง",
    "WDYHQ": "คูปองของฉัน",
    "KYYHQ": "คูปองใช้ได้",
    "YuanKeYong": "฿ ใช้ได้",
    "ChaKanDingDan": "ดูคำสั่งซื้อ",
    "ShangPinHanShui": "สินค้ารวมภาษี",
    "SPWHS": "สินค้าไม่รวมภาษี",
    "GeDian": "แต้ม",
    "QueRenDingDan": "ยืนยันคำสั่งซื้อ",
    "XZSHDZ": "เพิ่มที่อยู่",
    "ShangPinQingDan": "รายการสินค้า",
    "WKYYHQ": "ไม่มีคูปอง",
    "HuChi": "ขัดแย้ง",
    "DaiJinQuan": "บัตรกำนัล",
    "YunFei": "ค่าจัดส่ง",
    "ShuiFei": "ภาษี",
    "WKYYY": "เหตุผลไม่ใช้ได้",
    "YHQYGQ": "คูปองหมดอายุ",
    "WDYHQSYSJ": "ยังไม่ถึงเวลาที่ใช้ได้",
    "ZDSPJEWMZ": "ยอดสินค้าไม่ถึง",
    "BKYYHQ": "คูปองใช้ไม่ได้",
    "RMBJE": "จำนวนหยวน",
    "QXZPSFS": "เลือกวิธีจัดส่ง",
    "1ZSP_G": "1 ประเภท, รวม",
    "YSSP_YJ": "พรีออเดอร์, ประมาณ",
    "JiaoHuoRiQi": "วันจัดส่ง",
    "GMJLY": "ข้อความถึงผู้ขาย",
    "ZhengZaiChuLi...": "กำลังประมวลผล...",
    "FSCSP": "ไม่ใช่สินค้าร้าน",
    "ZZCLTXM": "กำลังประมวลบาร์โค้ด...",
    "SPTJCG": "เพิ่มสินค้าแล้ว",
    "QSTXM": "สแกนบาร์โค้ด",
    "SFSCDQSP": "ลบสินค้านี้?",
    "BQ_ZBDXGSP": "ขออภัย ไม่พบสินค้า",
    "XuanZeDanWei": "เลือกหน่วย",
    "JRGWC": "เพิ่มลงตะกร้า",
    "QXXZDJRSP": "เลือกสินค้าก่อน",
    "ZhengZaiChuLi": "กำลังประมวลผล",
    "JRGWCCG": "เพิ่มลงตะกร้าแล้ว",
    "ZanWuShangPin": "ไม่มีสินค้า",
    "XTYJBNFZSP": "คัดลอกลิงก์สินค้าแล้ว!",
       "NKYHDDYDYJ": "คุณจะได้รับคอมมิชชัน คอมมิชชันดูได้ใน 'ของฉัน", // You can earn commission. View in "My"
    "LiChaKan": "'", // Closing quote for context
    "WeiXinHaoYou": "เพื่อน WeChat", // WeChat Friends
    "ErWeiMa": "คิวอาร์โค้ด", // QR Code
    "CASBEWM": "สแกนคิวอาร์โค้ด", // Scan QR Code
    "FZSB_QCXFZ": "คัดลอกไม่สำเร็จ โปรดลองอีกครั้ง!", // Copy failed, try again
    "TWEWM": "คิวอาร์โค้ดพร้อมข้อความ", // QR Code with text
    "BCDXC": "บันทึกลงอัลบั้ม", // Save to album
    "CATPBCDXC": "กดค้างเพื่อบันทึกลงอัลบั้ม", // Long press to save
    "FuZhiLianJie": "คัดลอกลิงก์", // Copy link
    "FXZYJ": "แบ่งปันเพื่อรับคอมมิชชัน", // Share to earn commission
    "YJZGKZQYJ": "คอมมิชชันสูงสุด", // Max commission
    "FXSPGLSKH": "แบ่งปันสินค้าให้ลูกค้ารายย่อย", // Share products to retail customers
    "FXHJSCNZSD": "แชร์แล้วจะสร้างมินิช็อปส่วนตัว ตั้งราคาและข้อมูลติดต่อเพื่อดึงดูดลูกค้า", // Share to create your mobile shop
    "WSCDQJG_ND": "ราคาปัจจุบัน: ราคาคุณ ×", // Current shop price: Your price ×
    "DaiSheZhi": "ยังไม่ตั้งค่า", // Not set
    "PengYouQuan": "โมเมนต์", // Moments
    "GGFXSZ": "เปลี่ยนการตั้งค่าแชร์", // Change share settings
    "QXSRZH": "กรุณาใส่บัญชี", // Please enter account
    "MMGSCW_6_20W": "รูปแบบรหัสผ่านไม่ถูกต้อง (6-20 ตัวอักษร/ตัวเลข)", // Password format error
    "BDYYZH": "เชื่อมโยงบัญชีที่มีอยู่", // Link existing account
    "WXKJDL": "ล็อกอินด่วนด้วย WeChat", // Quick login with WeChat
    "BangDingZhangHao": "เชื่อมโยงบัญชี", // Link account
    "YYZH_QDL": "มีบัญชีอยู่แล้ว? ล็อกอิน", // Have account? Login
    "ZCXZH": "สมัครบัญชีใหม่", // Register new account
    "HuanYingNi": "ยินดีต้อนรับ", // Welcome
    "ZH_SJHM": "บัญชี/เบอร์โทรศัพท์", // Account/Phone
    "MiMa": "รหัสผ่าน", // Password
    "QDLHCZ": "กรุณาล็อกอินก่อนดำเนินการ", // Please login first
    "DengLuGuoQi": "เซสชั่นหมดอายุ", // Session expired
    "DLGQ_QCXDL": "เซสชั่นหมดอายุ กรุณาล็อกอินใหม่", // Session expired, relogin
    "KCBZ_BNTJG": "สต็อกไม่พอ ไม่สามารถเพิ่มได้", // Stock insufficient
    "ZhiFuChengGong": "ชำระเงินสำเร็จ!", // Payment successful
    "ZFSB_QCXCS": "ชำระเงินล้มเหลว โปรดลองอีกครั้ง!", // Payment failed, try again
    "QXXZGG": "กรุณาเลือกสเปคก่อน", // Select specs first
    "SXGGX": "สเปคที่เลือกต้องการ", // Selected specs require
    "GMSLXYQDL_": "จำนวนต่ำกว่าขั้นต่ำ กรุณาเลือกใหม่!", // Below min quantity
    "GMSLDYXDL_": "จำนวนเกินขีดจำกัด กรุณาเลือกใหม่!", // Exceeds max quantity
    "ShangPinBianHao": "รหัสสินค้า", // Product ID
    "QiDing": "ขั้นต่ำต่อออเดอร์", // Min order quantity
    "SXGGDGSLBK": "เกินขีดจำกัดการสั่งซื้อ", // Exceeds order limit
    "KCBZ_BNTJ": "สต็อกไม่พอ ไม่สามารถเพิ่ม", // Cannot add, stock low
    "QXXZSP": "กรุณาเลือกสินค้าก่อน", // Select product first
    "SLBNW0": "จำนวนไม่สามารถเป็น 0", // Quantity can't be 0
    "QXZGG": "กรุณาเลือกสเปค", // Please select specs
    "LiJiYuDing": "จองทันที", // Book now
    "ShouYe": "หน้าหลัก", // Home
    "ShangPin": "สินค้า", // Products
    "DingDan": "คำสั่งซื้อ", // Orders
    "WoDe": "ของฉัน", // Profile
    "ZhiFuQuXiao": "ยกเลิกการชำระ", // Payment canceled
    "ShangPinYongJin": "คอมมิชชันสินค้า", // Product commission
    "YaoQingJiangLi": "รางวัลการเชิญ", // Invitation reward
    "TiXian": "ถอนเงิน", // Withdraw
    "TiXianBoHui": "การถอนถูกปฏิเสธ", // Withdrawal rejected
    "ZhuanWeiYuE": "โอนเป็นยอดคงเหลือ", // Transfer to balance
    "Jin7Tian": "7 วันที่ผ่านมา", // Last 7 days
    "Jin30Tian": "30 วันที่ผ่านมา", // Last 30 days
    "ShouZhiMingXi": "ประวัติรายการ", // Transaction history
    "ZanWuShuJu": "ไม่มีข้อมูล", // No data
    "WoDeKeHu": "ลูกค้าของฉัน", // My customers
    "WoDeYaoQing": "การเชิญของฉัน", // My invitations
    "LeiJiKeHu": "ลูกค้าทั้งหมด", // Total customers
    "LeiJiDingDan": "คำสั่งซื้อทั้งหมด", // Total orders
    "YaoQingHaoYou": "เชิญเพื่อน", // Invite friends
    "LeiJiYaoQing": "การเชิญทั้งหมด", // Total invitations
    "LJSY_Y_": "รายได้รวม (฿)", // Total income (฿)
    "BHDJS": "รวมที่รอดำเนินการ", // Including pending
    "J7TSY_Y_": "รายได้ 7 วัน (฿)", // 7-day income (฿)
    "J7TXZKH_R_": "ลูกค้าใหม่ 7 วัน (คน)", // New customers 7 days
    "KTXYJ": "คอมมิชชันที่ถอนได้", // Withdrawable commission
    "XYJYO": "สู้ๆ!", // Keep it up!
    "ChangJianWenTi": "คำถามที่พบบ่อย", // FAQ
    "Q_ZMYJX_TG": "ถาม: วิธี 'โปรโมทเพื่อหารายได้'?", // Q: How to promote?
    "A_FXDPND_Z_": "ตอบ: แชร์ลิงก์สินค้าภาพ 'รับคอมมิชชัน' เมื่อเพื่อนสั่งซื้อ คุณจะได้คอมมิชชัน", // A: Share product links
    "Q_RHJS_TGZ": "ถาม: คำนวณคอมมิชชันอย่างไร?", // Q: How is commission calculated?
    "A_MGD_Z_TBD": "ตอบ: ทุกสินค้ามีอัตราคอมมิชชัน คำนวณจากยอดสั่งซื้อจริง", // A: Commission rate per product
    "Q_TGZQ_DSY": "ถาม: เมื่อไรได้คอมมิชชัน?", // Q: When to receive commission?
    "A_HYTGNDFX": "ตอบ: หลังจากลูกค้ายืนยันการรับสินค้า คอมมิชชันเข้าบัญชีคุณ", // A: After customer confirms
    "Q_LJKH_LJY": "ถาม: ทำไมไม่มีรูป/ชื่อในรายการ?", // Q: Why no avatars/names?
    "A_WXYQZYGZ": "ตอบ: WeChat ต้องบัญชีตรวจสอบแล้ว หากร้านไม่ยืนยัน ติดตาม 'YunShangDingHuo'", // A: WeChat requires verification
    "Q_WSMWASSG": "ถาม: ทำไมไม่ได้คอมมิชชัน?", // Q: Why no commission?
    "A_1_HYKNBW": "ตอบ: 1) ลูกค้าไม่เชื่อมโยงกับคุณ 2) ลิงก์เปิดนอก WeChat 3) ติดต่อฝ่ายสนับสนุน", // A: Possible reasons
    "XiaoShouZhongXin": "ศูนย์ขาย", // Sales center
    "SPMC_GG_BH": "ชื่อ / สเปค / รหัส", // Name/Specs/ID
    "YuJiZhuan": "รายได้โดยประมาณ", // Estimated income
    "YaoQingKa": "การ์ดเชิญ", // Invitation card
    "YNYQJR_TGY": "ร่วมกับเรา รับรางวัล", // Join us, get rewards
    "DJBCDXC": "บันทึกลงอัลบั้ม", // Save to album
    "JYQKFSGHY_": "แชร์การ์ดกับเพื่อน", // Share card with friends
    "HuanYingJiaRu": "ยินดีต้อนรับ", // Welcome
    "YQNCW": "เชิญคุณเป็น", // Invite you to be
    "LiJiJiaRu": "เข้าร่วมทันที", // Join now
    "YuJiYongJin": "คอมมิชชันโดยประมาณ", // Estimated commission
    "YongJin": "คอมมิชชัน", // Commission
    "YuJiJiangLi": "รางวัลโดยประมาณ", // Estimated reward
    "JiangLi": "รางวัล", // Reward
    "SPTGDD": "ออเดอร์โปรโมท", // Promotion orders
    "YQJLDD": "ออเดอร์การเชิญ", // Invitation orders
    "YeJiTongJi": "สถิติผลงาน", // Performance stats
    "LJKH_R_": "ลูกค้าทั้งหมด (คน)", // Total customers
    "SPYJ_Y_": "คอมมิชชันสินค้า (฿)", // Product commission (฿)
    "HanDaiJieSuan": "รวมที่รอดำเนินการ", // Including pending
    "XGMCJS": "คำอธิบาย", // Terms explanation
    "KeHu": "ลูกค้า", // Customer
    "HFXYBDLKHG": "ผู้ซื้อที่เชื่อมโยงกับผู้ขาย", // Buyers linked to seller
    "YaoQing": "การเชิญ", // Invitation
    "FXYCGYQDXJ": "ผู้ขายที่คุณเชิญ", // Sellers you invited
    "FXYTJKHGMH": "คอมมิชชันจากลูกค้า", // Commission from customers
    "XJFXYTGSPH": "รางวัลจากการเชิญ", // Reward from invitations
    "NiCheng": "ชื่อเล่น", // Nickname
    "HaiBaoTuiGuang": "โปสเตอร์โปรโมท", // Promotion poster
    "JHBFSGHY_T": "แชร์โปสเตอร์กับเพื่อน", // Share poster with friends
    "JieSuanZhongXin": "ศูนย์ชำระเงิน", // Settlement center
    "KTXJE": "จำนวนที่ถอนได้", // Withdrawable amount
    "TiXianJiLu": "ประวัติการถอน", // Withdrawal history
    "KHRXMBNWK": "กรุณากรอกชื่อเจ้าของบัญชี!", // Account holder name required
    "KHHBNWK": "กรุณาเลือกธนาคาร!", // Bank required
    "YHKHBNWK": "กรุณากรอกเลขบัญชี!", // Account number required
    "SFZTPBNWK": "กรุณาอัปโหลดบัตรประชาชน!", // ID card required
    "YHKTPBNWK": "กรุณาอัปโหลดบัตรธนาคาร!", // Bank card required
    "BaoCunChengGong": "บันทึกสำเร็จ!", // Save successful
    "SCSFZ": "อัปโหลดบัตรประชาชน", // Upload ID card
    "SCYHK": "อัปโหลดบัตรธนาคาร", // Upload bank card
    "BaoCun": "บันทึก", // Save
    "TiXianZhangHu": "บัญชีถอนเงิน", // Withdrawal account
    "TS_QTXZSXX": "สำคัญ: กรอกข้อมูลจริงเพื่อการตรวจสอบ", // Enter real info for verification
    "KHRXM": "ชื่อเจ้าของบัญชี", // Account holder
    "KaiHuHang": "ธนาคาร", // Bank
    "YinhangKaHao": "เลขบัญชีธนาคาร", // Bank account number
    "QSRZSXM": "กรอกชื่อจริง", // Enter real name
    "QSRKHHMC": "กรอกชื่อธนาคาร", // Enter bank name
    "QSRYHKH": "กรอกเลขบัญชี", // Enter account number
    "QXSZTXZH": "กรุณาตั้งค่าบัญชีถอนก่อน", // Set withdrawal account first
    "QuSheZhi": "ไปตั้งค่า", // Go to settings
    "JEXY10Y_BKT": "น้อยกว่า 10฿ ถอนไม่ได้!", // Below 10฿ cannot withdraw
    "JECGKTXJE": "เกินจำนวนที่ถอนได้!", // Exceeds withdrawable amount
    "CGDRKTXSX_": "เกินวงเงินถอนรายวัน (สูงสุด 20,000฿/วัน)!", // Exceeds daily limit
    "QueDingJiang": "ยืนยันโอน", // Confirm transfer
    "ZhuanDaoYuE": "เป็นยอดคงเหลือ?", // To balance?
    "1_JEDY10YSB": "1. ขั้นต่ำ 10฿ ในการถอน", // Min 10฿ for withdrawal
    "2_BCTXDZSJ": "2. การถอนใช้เวลา 5 วันทำการ วงเงิน: 20,000฿/วัน", // Withdrawal processing time
    "3_GBSRWHSS": "3. รายได้ต้องเสียภาษี ชำระภาษีเอง", // Income subject to tax
    "4_ZDYEKYYS": "4. ใช้ยอดคงเหลือช้อปปิ้งได้", // Balance usable for shopping
    "TXSQCG_QDD": "คำขอถอนเงินรับแล้ว รอการตรวจสอบ", // Withdrawal request received
    "JEDYKTXJE_": "เกินจำนวนที่ถอนได้ โอนไม่ได้!", // Exceeds withdrawable amount
    "ZZYECG_QDG": "โอนเข้ายอดคงเหลือสำเร็จ ตรวจสอบในโปรไฟล์!", // Transfer to balance success
    "BenCiTiXian": "การถอนนี้", // This withdrawal
    "ZhuangDaoYuE": "เป็นยอดคงเหลือ", // To balance
    "TiXianDao": "ถอนเข้าสู่", // Withdraw to
    "JEW0BKZZYE": "จำนวน 0฿ โอนไม่ได้!", // Zero amount cannot transfer
    "DRTXSX2WY": "วงเงินรายวัน 20,000฿", // Daily limit 20,000฿
    "QuanBuTiXian": "ถอนทั้งหมด", // Withdraw all
    "QueRenTiXian": "ยืนยันการถอน", // Confirm withdrawal
    "ZuiChangGouMai": "ซื้อบ่อย", // Frequently bought
    "MoRenPaiXu": "เรียงตามค่าเริ่มต้น", // Default sort
    "ZongHe": "แนะนำ", // Recommended
    "FenLei": "หมวดหมู่", // Categories
    "XiaoLiangYouXian": "เรียงตามยอดขาย", // Sort by sales
    "XiaoLiang": "ยอดขาย", // Sales
    "JiaGe": "ราคา", // Price
    "ShaiXuan": "ตัวกรอง", // Filter
    "ZuiJinGouMai": "ซื้อล่าสุด", // Recently bought
    "CuXiaoYouXian": "เรียงตามโปรโมชัน", // Sort by promotions
    "QuanBuFenLei": "ทุกหมวดหมู่", // All categories
    "ZhiKanCuXiao": "ดูโปรโมชันเท่านั้น", // Only promotions
    "XuanZeFenLei": "เลือกหมวดหมู่", // Select category
    "QXZFL": "กรุณาเลือกหมวดหมู่", // Please select category
    "ZWXGSP": "ไม่พบสินค้า", // No products found
    "PinPaiHui": "แบรนด์", // Brands
    "TuiJianFenLei": "หมวดหมู่แนะนำ", // Recommended categories
    "ShangPinFenLei": "หมวดหมู่สินค้า", // Product categories
    "GengDuo": "เพิ่มเติม", // More
    "DLZHBSDQQY": "บัญชีไม่ใช่ลูกค้าปัจจุบัน", // Account not current customer
    "GXNHQ": "ยินดีด้วย! คุณได้รับ", // Congratulations! You got
    "SZWSCJGH_C": "ตั้งราคาก่อนแชร์", // Set price before sharing
    "JHDJSHS_": "โปรโมชันสิ้นสุดใน:", // Promotion ends in:
    "DLHKFX": "ต้องล็อกอินเพื่อแชร์", // Login to share
    "ZZHQXX_QSH": "กำลังรับข้อมูล โปรดลองใหม่", // Getting data, try again
    "Zhang": "ใบ", // Counter for coupons
    "Tian": "วัน", // Days
    "QXZGGZQPD": "กรุณาเลือกสเปคก่อน", // Select specs first
    "Yuan": "฿", // Thai Baht
    "XS_F_M": "ชม./นาที/วิ", // Hr/Min/Sec
    "WoDeJiFen": "คะแนนของฉัน", // My points
    "DaBaiLe": "คุณทำได้ดีกว่า", // You beat
    "JiFen": "คะแนน", // Points
    "DeHuiYuan": "สมาชิก", // Members
    "ZhuanJiFen": "รับคะแนน", // Earn points
    "JiFenMingXi": "ประวัติคะแนน", // Points history
    "HuanLiPin": "แลกของรางวัล", // Redeem gifts
    "CKGDHL": "ดูของรางวัลทั้งหมด", // View all gifts
    "ChaDingDan": "ออเดอร์ของฉัน", // My orders
    "DHSLBNCG": "สูงสุด {num} ในการแลก", // Max {num} for exchange
    "DuiHuanShuLiang": "จำนวนแลก", // Redeem quantity
    "SuoXuJiFen": "คะแนนที่ต้องการ", // Points required
    "LiPinXiangQing": "รายละเอียดของรางวัล", // Gift details
    "WoYaoDuiHuan": "ฉันอยากแลก", // I want to redeem
    "ShengYu": "เหลือ", // Left
    "TuWenXiangQing": "คำอธิบาย", // Description
    "YiDuiWan": "หมดแล้ว", // Out of stock
    "FenLeiShaiXuan": "ตัวกรองหมวดหมู่", // Category filter
    "JiFenShaiXuan": "ตัวกรองคะแนน", // Points filter
    "JiFenShouRu": "คะแนนเข้า", // Points earned
    "JiFenZhiChu": "คะแนนออก", // Points spent
    "DingDanGenZong": "ติดตามออเดอร์", // Track order
    "WuLiuGongSi": "บริษัทขนส่ง", // Logistics company
    "WuLiuDanHao": "เลขติดตาม", // Tracking number
    "DingDanLieBiao": "รายการออเดอร์", // Order list
    "YiFaHuo": "จัดส่งแล้ว", // Shipped
    "JiFenDingDan": "ออเดอร์ใช้คะแนน", // Points orders
    "ChaKanWuLiu": "ติดตามพัสดุ", // Track parcel
    "LPSLBZ_QCX": "ของรางวัลไม่พอ โปรดลองใหม่", // Gifts insufficient
    "JiFenBuZu": "คะแนนไม่พอ", // Points insufficient
    "ZhiFuXinXi": "ข้อมูลการชำระ", // Payment info
    "JiXuGuangGuang": "ช้อปต่อ", // Continue shopping
    "QTXSHXX": "กรุณากรอกที่อยู่จัดส่ง", // Enter shipping address
    "DuiHuanChengGong": "แลกสำเร็จ", // Redeem successful
    "LPDHQR": "ยืนยันการแลก", // Confirm redemption
    "SCCKJ": "ราคาตลาด", // Market price
    "LiJiZhiFu": "ชำระทันที", // Pay now
    "DingDanXiangQing": "รายละเอียดออเดอร์", // Order details
    "DingDanZhuangTai": "สถานะออเดอร์", // Order status
    "DingDanBianHao": "เลขที่ออเดอร์", // Order number
    "DuiHuanShiJian": "เวลาแลก", // Redemption time
    "ShouHuoXinXi": "ข้อมูลผู้รับ", // Receiver info
    "HuaFeiJiFen": "คะแนนที่ใช้", // Points spent
    "QDZJF": "รับคะแนนจากการล็อกอิน", // Earn points by login
    "XDZJF": "รับคะแนนจากออเดอร์", // Earn points by orders
    "DDWCHKHDYD": "หลังยืนยันออเดอร์ รับคะแนน = ยอดสั่งซื้อ *", // After order, get points
    "1_MRQD_JL": "1. ล็อกอินรายวัน: +", // Daily login bonus
    "2_LXQD3T_EW": "2. ล็อกอินต่อเนื่อง 3 วัน: +", // 3-day streak
    "3_LXQD7T_EW": "3. ล็อกอินต่อเนื่อง 7 วัน: +", // 7-day streak
    "BeiDeJiFen": "เท่าของคะแนน", // Times points
    "DLZJF": "รับคะแนนจากการล็อกอิน", // Earn points by login
    "MeiRiDengLu": "ล็อกอินรายวัน", // Daily login
    "SC_JL": "ร้านค้า: +", // Shop bonus
    "GuiZe": "กฎ", // Rules
    "QianDaoYouLi": "รางวัลการล็อกอิน", // Login rewards
    "QianDaoGuiZe": "กฎการล็อกอิน", // Login rules
    "YLXQD": "ล็อกอินต่อเนื่อง", // Login streak
    "QDCG_NYJLX": "ล็อกอินสำเร็จ! คุณล็อกอิน", // Login success
    "QDCG_BCHD": "ล็อกอินสำเร็จ! รับ", // Login success
    "QSRBZ": "กรุณากรอกหมายเหตุ", // Enter note
    "DingDanZengPin": "ของแถมออเดอร์", // Order freebies
    "GuiGeBianHao": "รหัสสเปค", // Spec code
    "GuiGe": "สเปค", // Specs
    "CDDWXFK": "ออเดอร์นี้ไม่ต้องชำระ", // No payment needed
    "YHYEBZ": "ยอดคงเหลือไม่เพียงพอ!", // Insufficient balance
    "ZFJEBNW0": "จำนวนชำระไม่สามารถเป็น 0!", // Payment can't be zero
    "ZFJEBNDYDD": "จำนวนชำระเกินยอดค้างชำระ", // Payment exceeds pending
    "DFKJE": "ยอดค้างชำระ", // Pending payment
    "FuKuanFangShi": "วิธีชำระ", // Payment method
    "FuJian": "ไฟล์แนบ", // Attachment
    "ZHYFZ": "คัดลอกบัญชีแล้ว", // Account copied
    "GHSKZH": "เปลี่ยนบัญชีรับเงิน", // Change receiving account
    "SYXXZFQSCF": "กรุณาอัปโหลดหลักฐานการชำระ", // Upload payment proof
    "XXZF_BXXZS": "ชำระออฟไลน์ ต้องเลือกบัญชีรับเงิน", // Offline payment requires account
    "DingDanZhiFu": "ชำระออเดอร์", // Order payment
    "ZFFS_HDFK": "เก็บเงินปลายทาง", // Cash on delivery
    "BCFKJE": "ยอดชำระนี้", // This payment
    "YuE": "ยอดคงเหลือ", // Balance
    "FuZhiZhangHao": "คัดลอกรายละเอียด", // Copy details
    "WSZXCXZFPZ": "ยังไม่ตั้งค่าชำระเงิน", // Payment settings not set
    "XCXZFZHJY": "บัญชีชำระเงินถูกปิดการใช้งาน", // Payment account disabled
    "SRZFJE": "กรอกจำนวนชำระ", // Enter payment amount
    "FuKuanZhangHu": "บัญชีชำระ", // Payment account
    "QueRenZhiFu": "ยืนยันการชำระ", // Confirm payment
       "ShaoHouZhiFu": "ชำระทีหลัง", // Pay Later
    "FKJLYTJ_DD": "เพิ่มบันทึกการชำระแล้ว รอตรวจสอบการเงิน", // Payment record added, awaiting finance review
    "JiXuGuang": "ช้อปต่อ", // Continue Shopping
    "BenCiFuKuan": "การชำระนี้", // This Payment
    "FuKuanChengGong": "ชำระสำเร็จ", // Payment Successful
    "ZhiFuFangShi": "วิธีการชำระ", // Payment Method
    "ZhiFuDingDan": "ชำระออเดอร์", // Pay Order
    "QXXZSXZFDD": "กรุณาเลือกออเดอร์ที่ต้องการชำระก่อน", // Please select orders to pay
    "PiLiangFuKuan": "ชำระทีเดียวทั้งหมด", // Pay All at Once
    "FuKuan": "ชำระเงิน", // Pay
    "'QuFuKuan'": "ไปชำระเงิน", // Go to Pay
    "YingFuJinE": "จำนวนที่ต้องชำระ", // Amount Payable
    "XiaDanShiJian": "เวลาสั่งซื้อ", // Order Time
    "SFQRSH": "ยืนยันรับสินค้าหรือไม่?", // Confirm receipt?
    "DDQRSH_": "ยืนยันรับสินค้าออเดอร์?", // Confirm order receipt?
    "DFHSP": "สินค้ารอจัดส่ง", // Products Pending Shipment
    "ShangPinShuLiang": "จำนวนสินค้า", // Product Quantity
    "ChuKuShiJian": "เวลาออกจากคลัง", // Warehouse Exit Time
    "FaHuoShiJian": "เวลาจัดส่ง", // Shipping Time
    "WuLiuBeiZhu": "หมายเหตุการจัดส่ง", // Shipping Notes
    "QueRenShouHuo": "ยืนยันการรับสินค้า", // Confirm Receipt
    "RYFK_QJSYG": "หากชำระแล้ว โปรดติดต่อแอดมิน", // If paid, contact admin
    "QSRQXYY": "กรอกเหตุผลการยกเลิก", // Enter cancellation reason
    "H_DDJZDGB_QJKF": "หลังจาก {time} ออเดอร์จะยกเลิกอัตโนมัติ โปรดชำระโดยเร็ว", // After {time} order auto-cancels
    "TuiHuoQingKuang": "สถานะการคืนสินค้า", // Return Status
    "DingDanZongE": "ยอดรวมออเดอร์", // Order Total
    "DingDanBeiZhu": "หมายเหตุออเดอร์", // Order Notes
    "FaHuoQingKuang": "สถานะการจัดส่ง", // Shipping Status
    "DingDanFuJian": "ไฟล์แนบออเดอร์", // Order Attachments
    "ShenQingTuiHuo": "ขอคืนสินค้า", // Request Return
    "G1TDSHJL_QRS": "ยืนยันรับสินค้า {num} รายการ?", // Confirm receive {num} items?
    "DaiXiaDan": "สั่งซื้อแทน", // Order on Behalf
    "DingDanHao": "เลขที่ออเดอร์", // Order Number
    "XiaDanFangShi": "วิธีการสั่งซื้อ", // Ordering Method
    "TuiHuoDan": "ใบคืนสินค้า", // Return Slip
    "ShangPinZongE": "ยอดรวมสินค้า", // Product Total
    "YunFei_ZongZhong": "ค่าจัดส่ง (น้ำหนักรวม", // Shipping Fee (Total Weight
    "SF_SPWS": "ภาษี (สินค้าไม่รวมภาษี", // Tax (Ex-tax Products
    "TePiJia": "ราคาพิเศษ", // Special Price
    "FuKuanQingKuang": "สถานะการชำระ", // Payment Status
    "TiaoJiLu": "รายการ", // Entries
    "ZaiLaiYiDan": "สั่งซื้ออีกครั้ง", // Reorder
    "QDSCGDD_": "ยืนยันลบออเดอร์นี้?", // Confirm delete this order?
    "YiQueRen": "ยืนยันแล้ว", // Confirmed
    "YiShouHuo": "รับสินค้าแล้ว", // Received
    "DaiFuJinE": "ยอดค้างชำระ", // Pending Amount
    "YiFuJinE": "ยอดชำระแล้ว", // Paid Amount
    "ZanWuJiLu": "ไม่มีบันทึก", // No Records
    "SPMC_DDH": "ชื่อสินค้า / เลขที่ออเดอร์", // Product Name / Order Number
    "FuKuanZhuangTai": "สถานะการชำระ", // Payment Status
    "FaHuoZhuangTai": "สถานะการจัดส่ง", // Shipping Status
    "QiShiShiJian": "เวลาเริ่มต้น", // Start Time
    "ZhongZhiShiJian": "เวลาสิ้นสุด", // End Time
    "CaoZuoChengGong": "ดำเนินการสำเร็จ", // Operation Successful
    "ZBKGM": "ยังไม่สามารถซื้อได้", // Not Available for Purchase
    "DQDDSPYXJ": "สินค้าในออเดอร์หมดจำหน่ายแล้ว", // Products in order discontinued
    "DQDDBFSPYXJ": "สินค้าบางรายการในออเดอร์หมดจำหน่าย", // Some products discontinued
    "JTJSJSP": "เพิ่มเฉพาะสินค้าที่มีจำหน่าย", // Add Only Available Products
    "DingHuoDan": "ใบสั่งซื้อ", // Purchase Order
    "DingDanRiZhi": "ประวัติออเดอร์", // Order History
    "FuZhiChengGong": "คัดลอกสำเร็จ", // Copy Successful
    "FuZhiShiBai": "คัดลอกไม่สำเร็จ", // Copy Failed
    "FuZhi": "คัดลอก", // Copy
    "BoDa": "โทร", // Call
    "WCWLDHXX": "ไม่มีข้อมูลการจัดส่ง", // No Shipping Info
    "ZFCS_QCXXD": "เกินเวลาชำระ กรุณาสั่งซื้อใหม่", // Payment Timeout, Reorder
    "YQYYCKZF": "เปิดใช้งานการชำระด้วยยอดคงเหลือ", // Balance Payment Enabled
    "BNDYDFKJE": "ไม่สามารถเกินยอดค้างชำระ", // Cannot Exceed Pending Amount
    "ZFJEBNWK": "ต้องกรอกจำนวนชำระ", // Payment Amount Required
    "QXAPFK_FKH": "ชำระและอัปโหลดหลักฐานเพื่อการตรวจสอบ", // Pay and Upload Proof for Verification
    "DDTJCG_QJS": "ส่งคำสั่งซื้อสำเร็จ โปรดชำระโดยเร็ว", // Order Submitted, Pay Promptly
    "QXZFKFS": "กรุณาเลือกวิธีการชำระ", // Select Payment Method
    "SYYEZFH_HX": "หลังจากชำระด้วยยอดคงเหลือ ยังคงต้องชำระ", // After Paying with Balance, Still Need to Pay
    "FuKuanJiLu": "ประวัติการชำระ", // Payment Records
    "ZWFKJL": "ไม่มีบันทึกการชำระ", // No Payment Records
    "FuKuanXiangQing": "รายละเอียดการชำระ", // Payment Details
    "FuKuanJinE": "จำนวนเงิน", // Payment Amount
    "ZhiDan": "จัดทำโดย", // Prepared By
    "ShenHe": "ตรวจสอบ", // Review
    "ZuoFei": "ยกเลิก", // Cancel
    "ZuoFeiYuanYin": "เหตุผลการยกเลิก", // Cancellation Reason
    "GLDHD": "ออเดอร์ที่เกี่ยวข้อง", // Related Orders
    "HeXiaoJinE": "จำนวนเงินที่ตรวจสอบแล้ว", // Verified Amount
    "HeXiaoZhuangTai": "สถานะการตรวจสอบ", // Verification Status
    "DanJuZhuangTai": "สถานะเอกสาร", // Document Status
    "KeHuMingCheng": "ชื่อลูกค้า", // Customer Name
    "ZhangDanHao": "เลขที่บิล", // Bill Number
    "ShouKuanZhangHao": "บัญชีรับเงิน", // Receiving Account
    "ShouKuanShiJian": "เวลารับเงิน", // Receiving Time
    "FuKuanPingZheng": "หลักฐานการชำระ", // Payment Proof
    "GeFuJian": "ไฟล์แนบ", // Attachments
    "DingDanTongJi": "สถิติออเดอร์", // Order Statistics
    "DingHuo": "สั่งซื้อ", // Purchase
    "Bi": "ครั้ง", // Times
    "DDTJMX": "รายละเอียดสถิติออเดอร์", // Order Statistics Details
    "AGGTJ": "ตามสเปค", // By Specifications
    "AFLTJ": "ตามหมวดหมู่", // By Categories
    "DDJE_Y": "ยอดออเดอร์/฿", // Order Amount/฿
    "DHSP_Z": "สินค้าที่สั่งซื้อ", // Purchased Products
    "DingHuoDan_Bi": "ใบสั่งซื้อ/ครั้ง", // Purchase Orders/Times
    "DingHuoShangPin": "สินค้าที่สั่งซื้อ", // Purchased Products
    "JinE": "จำนวนเงิน", // Amount
    "TuiHuo": "คืนสินค้า", // Return
    "THDHWBC_QD": "ใบคืนยังไม่บันทึก ยืนยันออก?", // Return Slip Not Saved, Confirm Exit?
    "QSRSQTHJE": "กรอกจำนวนเงินที่ต้องการคืน", // Enter Requested Refund Amount
    "QSRTHJE": "กรอกจำนวนเงินคืน", // Enter Refund Amount
    "QSRBZXX": "กรอกข้อมูลหมายเหตุ", // Enter Note Information
    "YingTuiJinE": "จำนวนเงินที่ควรคืน", // Amount to be Refunded
    "TJTHSQ": "ส่งคำขอคืน", // Submit Return Request
    "QXXZDHQD": "กรุณาเลือกรายการสั่งซื้อก่อน", // Select Purchase Items First
    "DingHuoQingDan": "รายการสั่งซื้อ", // Purchase List
    "SQTHJE": "จำนวนเงินที่ขอคืน", // Requested Refund Amount
    "DJXZSP": "คลิกเลือกสินค้า", // Click to Select Products
    "TuiHuoJinE": "จำนวนเงินคืน", // Refund Amount
    "THDDXQ": "รายละเอียดใบคืน", // Return Details
    "YiTuiHuo": "คืนสินค้าแล้ว", // Returned
    "YiTuiKuan": "คืนเงินแล้ว", // Refunded
    "THDZT": "สถานะใบคืน", // Return Slip Status
    "TuiHuoDanHao": "เลขที่ใบคืน", // Return Slip Number
    "TuiHuoShiJian": "เวลาคืนสินค้า", // Return Time
    "TuiHuoCangKu": "คลังคืนสินค้า", // Return Warehouse
    "THLXR": "ผู้ติดต่อคืนสินค้า", // Return Contact Person
    "TuiHuoQingDan": "รายการคืนสินค้า", // Return List
    "TuiKuanZongE": "ยอดคืนเงินรวม", // Total Refund Amount
    "TuiKuanQingKuang": "สถานะการคืนเงิน", // Refund Status
    "DaiTuiJinE": "ยอดคืนค้าง", // Pending Refund
    "YiTuiJinE": "คืนเงินแล้ว", // Refunded Amount
    "SPMC_BH_GG": "ชื่อสินค้า / รหัส / สเปค / บาร์โค้ด", // Product Name / ID / Specs / Barcode
    "GZD1TJG": "พบ 1 ผลลัพธ์", // Found 1 Result
    "JiaRuQingDan": "เพิ่มในรายการ", // Add to List
    "ShenQingChengGong": "ส่งคำขอสำเร็จ", // Request Submitted
    "THDTJCG": "ส่งใบคืนสำเร็จ", // Return Slip Submitted
    "ChaKanXiangQing": "ดูรายละเอียด", // View Details
    "HDWKS_WDZL": "โปรโมชั่นยังไม่เริ่ม", // Promotion Not Started
    "HDYJS_XCZD": "โปรโมชั่นสิ้นสุดแล้ว", // Promotion Ended
    "ZWSZBT": "ยังไม่มีการตั้งชื่อ", // No Title Set
    "ChaKanGengDuo": "ดูเพิ่มเติม", // View More
    "HCDZSJC": "ข้อแตกต่างจากแคช", // Cache Discrepancy
    "DLCKCXJ": "เข้าสู่ระบบเพื่อดูราคาโปรโมชั่น", // Login to View Promotion Price
    "ZWSZCX": "ยังไม่ตั้งโปรโมชั่น", // No Promotion Set
    "JuKaiShi": "ก่อนเริ่ม", // Before Start
    "Song": "แถมฟรี", // Free Gift
    "JuJieShu": "ก่อนสิ้นสุด", // Before End
    "YiJieShu": "สิ้นสุดแล้ว", // Ended
    "XiaoXi": "การแจ้งเตือน", // Notifications
    "SaoMaXiaDan": "สั่งซื้อโดยสแกน", // Order by Scan
    "WZLCSJ": "ข้อมูลไม่รู้จัก", // Unknown Data
    "QXZYSDHAPP": "ดาวน์โหลดแอป YunShangDingHuo", // Download YunShangDingHuo App
    "QMTYQYGLD": "ประสบการณ์การจัดการธุรกิจแบบเต็มรูปแบบ", // Full Business Management Experience
    "XZYSDHAPP": "ดาวน์โหลด YunShangDingHuo", // Download YunShangDingHuo
    "HQGLDWZTY": "รับประสบการณ์การจัดการแบบเต็ม", // Get Full Management Experience
    "JXTYDHD": "ดำเนินการต่อที่ส่วนการสั่งซื้อ", // Continue at Order Section
    "GongGaoXiangQing": "รายละเอียดประกาศ", // Announcement Details
    "GongGaoFuJian": "ไฟล์แนบประกาศ", // Announcement Attachments
    "NFWDYMBCZO": "ไม่พบหน้า", // Page Not Found
    "KeNengYuanYin": "สาเหตุที่เป็นไปได้", // Possible Reasons
    "1_ZDZLSRCWD": "1. ที่อยู่ผิด", // 1. Wrong Address
    "2_DJLGQLJ": "2. ลิงก์หมดอายุ", // 2. Expired Link
    "GuanLiDuan": "การจัดการ", // Management
    "ZhuCe": "ลงทะเบียน", // Register
    "HYNTYYSDH": "ยินดีต้อนรับสู่ YunShangDingHuo", // Welcome to YunShangDingHuo
    "TYZHSJHDQG": "ข้อมูลบัญชีทดสอบจะถูกรีเซ็ตเป็นระยะ", // Test Account Data Periodically Reset
    "TYZHZDNRSJ": "ข้อมูลในบัญชีทดสอบเป็นข้อมูลหลอก", // Test Account Data is Fictitious
    "ZHZCCG": "ลงทะเบียนสำเร็จ", // Registration Successful
    "DengLuZhangHao": "บัญชีเข้าสู่ระบบ", // Login Account
    "CSMMW": "รหัสผ่านเริ่มต้น:", // Default Password:
    "GNFYHQL": "คุณได้รับคูปอง!", // You Got a Coupon!
    "Man1YuanKeYong": "ขั้นต่ำ {num}฿", // Min {num}฿
    "LQH1TNKY": "ใช้งานได้ {day} วัน", // Valid for {day} Days
    "YiJianLingQu": "รับทันที", // Get Now
    "GXNHD1ZYHQ": "คุณได้รับคูปอง", // You Got a Coupon
    "Gong1Yuan": "1฿", // 1฿
    "LiJiShiYong": "ใช้ทันที", // Use Now
    "NHWDL": "คุณยังไม่ได้เข้าสู่ระบบ", // You Haven't Logged In
    "ShangChengGongGao": "ประกาศร้านค้า", // Store Announcements
    "ZanWuGongGao": "ไม่มีประกาศ", // No Announcements
    "1GeFuJian": "{num} ไฟล์แนบ", // {num} Attachments
    "KouKuan": "การหักเงิน", // Deduction
    "ChongZhi_Kuan": "เติมเงิน", // Top-up
    "KouKuanZuoFei": "ยกเลิกการหักเงิน", // Cancel Deduction
    "ChongZhiZuoFei": "ยกเลิกการเติมเงิน", // Cancel Top-up
    "ZhangHuMingXi": "ประวัติบัญชี", // Account History
    "ZhangHuYuE": "ยอดคงเหลือบัญชี", // Account Balance
    "LiJiChongZhi": "เติมเงินทันที", // Top Up Now
    "CZJEBNXY1Y": "ขั้นต่ำ 1฿", // Min 1฿
    "QSRZQDSZ": "กรอกตัวเลข", // Enter Number
    "ZDYJE": "จำนวนที่กำหนดเอง", // Custom Amount
    "ZWKTXSCZGN": "ยังไม่เปิดให้เติมเงินออนไลน์", // Online Top-up Not Available
    "ShiFuJinE": "จำนวนที่ชำระ", // Amount Paid
    "ZhangHuChongZhi": "เติมเงินบัญชี", // Account Top-up
    "QXZCZJE": "เลือกจำนวนเงิน", // Select Amount
    "QSRCZJE": "กรอกจำนวนเงิน", // Enter Amount
    "QLXNDZSYWY": "ติดต่อพนักงานขายเพื่อเติมเงิน", // Contact Sales Rep for Top-up
    "ShouJia": "ราคาขาย", // Selling Price
    "YiShouQing": "ขายหมดแล้ว", // Sold Out
    "ChongZhiJinE": "จำนวนเงินที่เติม", // Top-up Amount
    "QueRenFuKuan": "ยืนยันการชำระ", // Confirm Payment
    "QSDDID": "ไม่มี ID ออเดอร์", // Missing Order ID
    "ChongZhiChengGong": "เติมเงินสำเร็จ", // Top-up Successful
    "ChongZhiShiBai": "เติมเงินไม่สำเร็จ", // Top-up Failed
    "CLZ_QSH...": "กำลังประมวลผล...", // Processing...
    "ChongZhiFangShi": "วิธีการเติมเงิน", // Top-up Method
    "ChongZhiShiJian": "เวลาเติมเงิน", // Top-up Time
    "JYLSH": "เลขที่ธุรกรรม", // Transaction Number
    "FanHuiShangCheng": "กลับไปที่ร้านค้า", // Return to Store
    "ZFSB_QCS": "ชำระไม่สำเร็จ โปรดลองอีกครั้ง", // Payment Failed, Try Again
    "ZFYQX": "ยกเลิกการชำระแล้ว", // Payment Canceled
    "ZFYC_QCS": "ข้อผิดพลาดในการชำระ โปรดลองอีกครั้ง", // Payment Error, Try Again
    "LingQuanZhongXin": "ศูนย์คูปอง", // Coupon Center
    "WeiShiYong": "ยังไม่ใช้", // Not Used
    "YiShiYong": "ใช้แล้ว", // Used
    "ZWYHQ": "ไม่มีคูปอง", // No Coupons
    "YiGouMai": "ซื้อแล้ว", // Purchased
    "ChangYongQingDan": "รายการที่ใช้บ่อย", // Frequently Used List
    "WoDeShouCang": "รายการโปรดของฉัน", // My Favorites
    "QuGouWuChe": "ไปที่ตะกร้า", // Go to Cart
    "GeShangPin": "สินค้า", // Products
    "YunShangDingHuo": "YunShangDingHuo", // YunShangDingHuo
    "QSRZH": "กรุณากรอกบัญชี!", // Please Enter Account!
    "QSRMM": "กรุณากรอกรหัสผ่าน!", // Please Enter Password!
    "QSRDLZH": "กรุณากรอกบัญชีเข้าสู่ระบบ", // Please Enter Login Account
    "JiZhuMiMa": "จำรหัสผ่าน", // Remember Password
    "WangJiMiMa": "ลืมรหัสผ่าน?", // Forgot Password?
    "DengLu": "เข้าสู่ระบบ", // Login
    "DLZHBCZ_QL": "บัญชีไม่มีอยู่ ติดต่อแอดมิน", // Account Doesn't Exist
    "GQYZHSBJY_": "บัญชีบริษัทถูกระงับ ติดต่อ YunShangDingHuo", // Company Account Suspended
    "GQYZHSYQJS_": "หมดระยะทดลองบัญชีบริษัทแล้ว", // Company Trial Ended
    "GQYZHYGQL_": "บัญชีบริษัทหมดอายุ ต้องต่ออายุ", // Company Account Expired
    "LiJiTiYan": "ทดลองทันที", // Try Now
    "YiChuChengGong": "นำออกสำเร็จ", // Removed Successfully
    "QueHuo": "สต็อกหมด", // Out of Stock
    "YCSCJ": "นำออกจากรายการโปรด", // Remove from Favorites
    "SheZhiChengGong": "ตั้งค่าสำเร็จ", // Settings Saved
    "ZWWDXX": "ไม่มีการแจ้งเตือนใหม่", // No New Notifications
    "QuanBuYiDu": "อ่านทั้งหมดแล้ว", // Mark All as Read
    "DingDanXiaoXi": "แจ้งเตือนออเดอร์", // Order Notifications
    "YiQiang": "รับแล้ว", // Already Taken
    "LiJiLingQu": "รับทันที", // Get Now
    "LingQuanHou": "หลังจากรับ", // After Receiving
    "TianNeiKeYong": "วันใช้งานได้", // Days Valid
    "QSRSJH": "กรุณากรอกหมายเลขโทรศัพท์", // Enter Phone Number
    "QSRYZM": "กรุณากรอกรหัสยืนยัน", // Enter Verification Code
    "QSRXMM": "กรุณากรอกรหัสผ่านใหม่", // Enter New Password
    "QSRZQSJGS": "รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง", // Invalid Phone Format
    "ChongZhiMiMa": "รีเซ็ตรหัสผ่าน", // Reset Password
    "QSRNDSJHM": "กรุณากรอกหมายเลขโทรศัพท์ของคุณ", // Enter Your Phone Number
    "QSRDXYZ": "กรุณากรอก SMS รหัสยืนยัน", // Enter SMS Verification Code
    "HQYZM": "รับรหัสยืนยัน", // Get Verification Code
    "HKCXHQ": "ส่งซ้ำได้ใน", // Resend In
    "QSR6_20WSZHZ": "รหัสผ่าน: 6-20 ตัวอักษร/ตัวเลข", // Password: 6-20 Letters/Numbers
    "QSRSPJGBL": "กรุณากรอกอัตราส่วนราคาสินค้า", // Enter Product Price Ratio
    "SPJGBLBXDY": "อัตราส่วนต้องอยู่ระหว่าง 100 ถึง 999.99", // Ratio Must Be 100-999.99
    "DPMCZBZCTS": "ชื่อร้าน: ไม่รองรับอักขระพิเศษ", // Store Name: No Special Chars
    "LXRZBZCTSF": "ผู้ติดต่อ: ไม่รองรับอักขระพิเศษ", // Contact Person: No Special Chars
    "LXFSZBZCTS": "ข้อมูลติดต่อ: ไม่รองรับอักขระพิเศษ", // Contact Info: No Special Chars
    "LXDZZBZCTS": "ที่อยู่: ไม่รองรับอักขระพิเศษ", // Address: No Special Chars
    "DPJJZBZCTS": "คำอธิบาย: ไม่รองรับอักขระพิเศษ", // Description: No Special Chars
    "QSRDPJJ_ZD": "คำอธิบาย (สูงสุด 50 ตัวอักษร)", // Description (Max 50 Chars)
    "FenXiangSheZhi": "การตั้งค่าแบ่งปัน", // Sharing Settings
    "NDWSCSPJG": "ราคาสินค้าในร้านของคุณ", // Your Store Product Prices
    "NDDHJ_": "ราคาที่คุณสั่งซื้อ ×", // Your Order Price ×
    "LXXX_KBJ_": "ข้อมูลติดต่อ (แก้ไขได้)", // Contact Info (Editable)
    "DianPuMingCheng": "ชื่อร้าน", // Store Name
    "JianJie": "คำอธิบาย", // Description
    "QSRDPMC": "กรอกชื่อร้าน", // Enter Store Name
    "LianXiRen": "ผู้ติดต่อ", // Contact Person
    "QSRLXR": "กรอกชื่อผู้ติดต่อ", // Enter Contact Name
    "LianXiFangShi": "ช่องทางติดต่อ", // Contact Method
    "QSRLXFS": "กรอกข้อมูลติดต่อ", // Enter Contact Info
    "LianXiDiZhi": "ที่อยู่ติดต่อ", // Contact Address
    "QSRLXDZ": "กรอกที่อยู่", // Enter Address
    "WoDeDingDan": "ออเดอร์ของฉัน", // My Orders
    "ZuiJinLiuLan": "ดูล่าสุด", // Recently Viewed
       "ShouCangShangPin": "สินค้าโปรด", // Favorite Products
    "BDYYZH_ZC": "เชื่อมโยงบัญชีที่มีอยู่ | สมัครบัญชีใหม่", // Link Existing Account | Register New
    "DL_ZC": "เข้าสู่ระบบ | ลงทะเบียน", // Login | Register
    "BangDingShouJi": "ผูกหมายเลขโทรศัพท์", // Bind Phone Number
    "TS_BDSJHM_": "คำแนะนำ: ผูกหมายเลขโทรศัพท์เพื่อความปลอดภัย", // Tip: Bind phone for security
    "ChaKanQuanBu": "ดูทั้งหมด", // View All
    "ShouHuoDiZhi": "ที่อยู่จัดส่ง", // Shipping Address
    "LianXiWoMen": "ติดต่อเรา", // Contact Us
    "SheZhi": "ตั้งค่า", // Settings
    "QuQianDao": "ไปลงชื่อเข้าใช้", // Go to Sign In
    "JiFenShangCheng": "ร้านค้าคะแนน", // Points Store
    "TuiGuangShangPin": "โปรโมตสินค้า", // Promote Products
    "QuChaKan": "ไปดู", // Go to View
    "JiFenHuanLi": "แลกคะแนนรับของรางวัล", // Redeem Points for Gifts
    "DYSPBQ": "พิมพ์ป้ายสินค้า", // Print Product Labels
    "GYYSDH": "เกี่ยวกับ YunShangDingHuo", // About YunShangDingHuo
    "YQHYSMEWM_": "สแกนคิวอาร์โค้ดเพื่อดาวน์โหลด", // Scan QR Code to Download
    "DangQianBanBen": "เวอร์ชันปัจจุบัน", // Current Version
    "ZWSHDZ": "ไม่มีที่อยู่จัดส่ง", // No Shipping Address
    "WoDeDiZhi": "ที่อยู่ของฉัน", // My Addresses
    "ZhiNengShiBie": "จดจำอัตโนมัติ", // Smart Recognition
    "ZTDZXXKZNS": "วางที่อยู่เพื่อจดจำชื่อ/โทรศัพท์/ที่อยู่", // Paste address to recognize info
    "MoRen": "ค่าเริ่มต้น", // Default
    "QRSCDZ": "ยืนยันลบที่อยู่?", // Confirm Delete Address?
    "SHRXM": "ชื่อผู้รับ", // Recipient Name
    "SJHMHGDDHZ": "กรุณากรอกโทรศัพท์มือถือหรือโทรศัพท์บ้าน", // Enter Mobile or Landline
    "QSRSHRXM": "กรุณากรอกชื่อผู้รับ", // Enter Recipient Name
    "ShouJiHaoMa": "หมายเลขโทรศัพท์", // Phone Number
    "GuDingDianHua": "โทรศัพท์บ้าน", // Landline Phone
    "QSRGDDH": "กรุณากรอกโทรศัพท์บ้าน", // Enter Landline
    "SuoZaiDiQu": "ภูมิภาค", // Region
    "QSRSZDQ": "กรุณาเลือกภูมิภาค", // Select Region
    "QSRXXDZ": "กรุณากรอกที่อยู่เต็ม!", // Enter Full Address!
    "QSRZQDSJHM": "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง", // Enter Valid Phone Number
    "QSRZQDGDDH": "กรุณากรอกโทรศัพท์บ้านที่ถูกต้อง", // Enter Valid Landline
    "XiangXiDiZhi": "ที่อยู่เต็ม", // Detailed Address
    "MoRenDiZhi": "ที่อยู่เริ่มต้น", // Default Address
    "SWMRDZ": "ตั้งเป็นค่าเริ่มต้น", // Set as Default
    "BCBSY": "บันทึกและใช้งาน", // Save and Use
    "QSRSJHM": "กรุณากรอกหมายเลขโทรศัพท์", // Enter Phone Number
    "GYHYZC": "ผู้ใช้นี้ลงทะเบียนแล้ว", // User Already Registered
    "GSJHMYJZCG": "หมายเลขโทรศัพท์ลงทะเบียนแล้ว", // Phone Number Registered
    "QZJDLJK": "กรุณาเข้าสู่ระบบโดยตรง", // Please Login Directly
    "QuDengLu": "ไปเข้าสู่ระบบ", // Go to Login
    "BDHKYTGSJH": "ผูกแล้วเข้าสู่ระบบได้ง่ายขึ้น", // Binding Facilitates Login
    "_BDHKYTGSJ": "*ผูกแล้วเข้าสู่ระบบได้ง่ายขึ้น", // *Binding Facilitates Login
    "QSRSJYZM": "กรุณากรอกรหัสยืนยัน SMS", // Enter SMS Verification Code
    "BDXSJ": "ผูกหมายเลขใหม่", // Bind New Phone
    "DXYZM": "รหัสยืนยัน SMS", // SMS Verification Code
    "XiaYiBu": "ขั้นตอนถัดไป", // Next Step
    "TGCBZ": "ข้ามขั้นตอนนี้", // Skip This Step
    "DBDSJHMBCZ": "หมายเลขโทรศัพท์ที่ผูกไม่มีอยู่!", // Phone to Bind Doesn't Exist!
    "QSRDLMM": "กรุณากรอกรหัสผ่าน!", // Enter Password!
    "_GSJHMYBDY": "*หมายเลขนี้ผูกกับบัญชีอื่นแล้ว", // *Phone Linked to Other Account
    "DQZHMMJTBW": "รหัสผ่านบัญชีจะซิงค์กัน", // Account Passwords Will Sync
    "DangQianZhangHao": "บัญชีปัจจุบัน", // Current Account
    "QDYJZ": "ยืนยันลบ", // Confirm Delete
    "JSPSCM": "สินค้า?", // Products?
    "ShanChuChengGong": "ลบสำเร็จ!", // Deleted Successfully!
    "SJGSCW": "รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง", // Invalid Phone Format
    "YXGSCW": "รูปแบบอีเมลไม่ถูกต้อง", // Invalid Email Format
    "WoDeZhangHao": "บัญชีของฉัน", // My Account
    "YouXiang": "อีเมล", // Email
    "ShouJi": "โทรศัพท์", // Phone
    "XingMing": "ชื่อ", // Name
    "XiuGaiTouXiang": "เปลี่ยนรูปโปรไฟล์", // Change Profile Picture
    "JiBenXinXi": "ข้อมูลพื้นฐาน", // Basic Info
    "ZhangHaoAnQuan": "ความปลอดภัยบัญชี", // Account Security
    "XiuGaiMiMa": "เปลี่ยนรหัสผ่าน", // Change Password
    "DianJiBangDing": "คลิกเพื่อผูก", // Click to Bind
    "RYDSHTY_QL": "หากสูญหายหรือเลิกใช้ กรุณาเปลี่ยน", // If Lost or Inactive, Change
    "WBZNDZHAQ_": "เพื่อความปลอดภัย กรุณาผูกหมายเลขโทรศัพท์", // For Security, Bind Phone
    "QSRNDXM": "กรุณากรอกชื่อของคุณ", // Enter Your Name
    "QSRNDDH": "กรุณากรอกหมายเลขโทรศัพท์ของคุณ", // Enter Your Phone Number
    "QSRNDYX": "กรุณากรอกอีเมลของคุณ", // Enter Your Email
    "QCHCHXCXDL": "ล้างแคชต้องเข้าสู่ระบบใหม่", // Clear Cache Requires Re-Login
    "QingChuHuanCun": "ล้างแคช", // Clear Cache
    "QDYQCHCM": "ยืนยันล้างแคช?", // Confirm Clear Cache?
    "TuiChuDengLu": "ออกจากระบบ", // Log Out
    "QieHuanZhangHao": "เปลี่ยนบัญชี", // Switch Account
    "LianXi": "ติดต่อ", // Contact
    "GongSiDianHua": "โทรศัพท์บริษัท", // Company Phone
    "DiZhi": "ที่อยู่", // Address
    "DJQMX": "รายละเอียดบัตรกำนัล", // Voucher Details
    "BuKeYong": "ไม่สามารถใช้งานได้", // Unavailable
    "KeYong": "สามารถใช้งานได้", // Available
    "ZWDJQ": "ไม่มีบัตรกำนัล", // No Vouchers
    "ZongEDu": "จำนวนเงินทั้งหมด", // Total Amount
    "FaFangShiJian": "เวลาออก", // Issuance Time
    "EDYYW": "จำนวนเต็มแล้ว", // Limit Reached
    "QBSPKY": "ใช้ได้กับสินค้าทั้งหมด", // All Products Applicable
    "WDDJQ": "บัตรกำนัลของฉัน", // My Vouchers
    "KYDJQ": "บัตรกำนัลที่ใช้ได้", // Usable Vouchers
    "DJQKDK": "บัตรกำนัลที่ใช้หักได้", // Deductible Vouchers
    "CKKYSP": "ดูสินค้าที่ใช้ได้", // View Applicable Products
    "BKYDJQ": "บัตรกำนัลที่ใช้ไม่ได้", // Unusable Vouchers
    "BKYYY_ZWFH": "เหตุผล: ไม่มีสินค้าที่ตรงเงื่อนไข", // Reason: No Eligible Products
    "DQSPWSCGGT": "สินค้านี้ไม่มีภาพสเปค ไม่สามารถจับคู่ไฟ!", // Product Missing Spec Images
    "BoFangShiPin": "เล่นวิดีโอ", // Play Video
    "Gong1GeGuiGe": "สเปค {num} ประเภท", // {num} Specifications
    "YiXuanGuiGe": "เลือกแล้ว", // Selected
    "XuanGuiGe": "เลือกสเปค", // Select Specs
    "LingQuan": "รับคูปอง", // Get Coupon
    "1ZhongCuXiao": "1 โปรโมชั่น", // 1 Promotion
    "1ZhangKeYong": "1 ใบที่ใช้ได้", // 1 Usable
    "ZuiGaoKeSheng": "ประหยัดสูงสุด", // Max Savings
    "ShangPinTaoCan": "ชุดสินค้า", // Product Package
    "Gong1GeTaoCan": "1 ชุด", // 1 Package
    "ShangPinCanShu": "พารามิเตอร์สินค้า", // Product Parameters
    "ZhanKai": "ขยาย", // Expand
    "YiShouCang": "เพิ่มในโปรดแล้ว", // Added to Favorites
    "ShouCang": "เพิ่มในโปรด", // Add to Favorites
    "KeFu": "บริการลูกค้า", // Customer Service
    "XiangQing": "รายละเอียด", // Details
    "TuiJian": "แนะนำ", // Recommended
    "BianHao": "เลขที่", // ID
    "ShangPinXinXi": "ข้อมูลสินค้า", // Product Info
    "KLYHQ": "คูปองที่รับได้", // Obtainable Coupons
    "KuCunBuZu": "สต็อกไม่เพียงพอ", // Insufficient Stock
    "DuoGuiGe": "หลายสเปค", // Multiple Specs
    "YiShou": "ขายแล้ว", // Sold
    "SWBHZ_YS": "ขายหมดแล้ว ขายไปแล้ว", // Sold Out
    "CuXiaoShangPin": "สินค้าโปรโมชั่น", // Promotional Products
    "NHWSRSSNR": "คุณยังไม่ได้ป้อนคำค้นหา", // You Haven't Entered Search
    "SouSuo": "ค้นหา", // Search
    "SSY1XGDSP": "ค้นหาสินค้าสำหรับ '{searchKey}'", // Search Products for '{searchKey}'
    "Yue1GeShangPin": "สินค้าประมาณ {num} รายการ", // About {num} Products
    "ZuiJinSouSuo": "ประวัติการค้นหา", // Search History
    "QingChu": "ล้าง", // Clear
    "ZWSSJL": "ไม่มีประวัติ", // No History
    "ZGJGBNDYZD": "ราคาสูงสุดต้องไม่ต่ำกว่าต่ำสุด", // Max Price Must >= Min Price
    "ShangPinBiaoQian": "แท็กสินค้า", // Product Tags
    "BuGaoYu1": "ไม่เกิน 1", // Not Above 1
    "BuDiYu1": "ไม่ต่ำกว่า 1", // Not Below 1
    "FengGe": "สไตล์", // Style
    "JiJiangKaiShi": "กำลังจะเริ่ม", // About to Start
    "QuanBuCuXiao": "โปรโมชั่นทั้งหมด", // All Promotions
    "Gong1JianShangPin": "สินค้า 1 รายการ", // 1 Product
    "Sheng": "ประหยัด", // Save
    "GTCZGWCZDS": "ชุดนี้ถึงจำนวนสูงสุดในรถเข็น", // Package Reached Cart Limit
    "GTCKCBZ_BK": "สต็อกไม่พอ ไม่สามารถเพิ่ม", // Insufficient Stock, Can't Add
    "JinSheng1Tao": "เหลือเพียง 1 ชุด", // Only 1 Set Left
    "XianGou1Tao": "ซื้อได้ 1 ชุด", // Limit 1 Set
    "TaoCanXiangQing": "รายละเอียดชุด", // Package Details
    "DanMaiJia": "ราคาซื้อเดี่ยว", // Single Price
    "TaoCanJia": "ราคาชุด", // Package Price
    "HDYJS": "โปรโมชั่นสิ้นสุด", // Promotion Ended
    "WDL_QXDL": "กรุณาเข้าสู่ระบบก่อน", // Please Login First
    "YiXiaShangPin": "สินค้าด้านล่าง", // Products Below
    "1ZhongGuiGe": "1 สเปค", // 1 Spec
    "YouKuCun": "มีสต็อก", // In Stock
    "BuGaoYu": "ไม่เกิน", // Not Above
    "BuDiYu": "ไม่ต่ำกว่า", // Not Below
    "CuXiao": "โปรโมชั่น", // Promotion
    "ZDYXXZ3G": "เลือกได้สูงสุด 3", // Max Select 3
    "GouMai": "ซื้อ", // Buy
    "Gong1Jian": "สินค้า {num} รายการ", // {num} Products
    "DLHCKJG": "เข้าสู่ระบบเพื่อดูราคา", // Login to View Prices
    "M1JZ1J": "ซื้อ {num} ชิ้น แถม {presentNum} ชิ้น", // Buy {num} Get {presentNum} Free
    "CZPF_ZZCXC": "ลองอีกครั้ง", // Try Again
    "XSZJJXZ": "ลดราคาแบบมีเวลาจำกัด", // Limited Time Discount
    "YXSPM1YZ1J_": "สินค้า {str} เพิ่มในรถเข็นรับส่วนลด!", // Products {str}, Add to Cart for Discount!
    "TiaoXingMa": "บาร์โค้ด", // Barcode
    "XiangGuanTuiJian": "แนะนำที่เกี่ยวข้อง", // Related Recommendations
    "YSSPBKJRGW": "สินค้าพรีออเดอร์ไม่สามารถเพิ่มในรถเข็น", // Pre-order Can't Add to Cart
    "YSSPBKLJGM": "สินค้าพรีออเดอร์ไม่สามารถซื้อได้ทันที", // Pre-order Can't Buy Immediately
    "SPSLYW": "จำนวนสินค้าไม่ถูกต้อง", // Incorrect Product Quantity
    "ShangPin1QiShou": "สินค้าขาย {num} ชิ้นขึ้นไป", // Min {num} to Sell
    "SPDGSLBNCG": "จำนวนการสั่งซื้อไม่เกิน {num}", // Order Quantity Limit {num}
    "QRYCXZSP": "ยืนยันลบสินค้าที่เลือก", // Confirm Delete Selected
    "QRYCSYSXSP": "ยืนยันลบสินค้าหมดอายุทั้งหมด", // Confirm Delete All Expired
    "QRYCXZSXSP": "ยืนยันลบสินค้าหมดอายุที่เลือก", // Confirm Delete Selected Expired
    "M1YZ1J": "ครบ {num}฿ แถม {presentNum} ชิ้น", // Spend {num}฿ Get {presentNum} Free
    "M1YJ1Y": "ลด {money}฿ เมื่อครบ {price}฿", // Save {money}฿ on {price}฿
    "M1J1": "ลด {money}฿ เมื่อครบ {price}", // Save {money}฿ on {price}
    "M1YD1Z": "ส่วนลด {money}% เมื่อครบ {price}฿", // {money}% Off on {price}฿
    "DDM1YHZ": "สั่งซื้อครบ {price}฿ รับของรางวัล", // Order Over {price}฿ Get Gift
    "YiHuoZeng": "ได้รับแล้ว", // Already Received
    "ZG1YLXM1YZ1": "ซื้อเพิ่ม {price}฿ รับ {str}", // Buy More {price}฿ Get {str}
    "ZG1JLXM1JZ1": "ซื้อเพิ่ม {num} ชิ้น รับ {str}", // Buy More {num} Items Get {str}
    "QCSXSP": "ล้างสินค้าหมดอายุ", // Clear Expired Products
    "YiXuanShangPin": "สินค้าที่เลือก", // Selected Products
    "QuJieSuan": "ไปชำระเงิน", // Go to Checkout
    "ShiXiaoShangPin": "สินค้าหมดอายุ", // Expired Products
    "DingDanGuanLi": "การจัดการคำสั่งซื้อ", // Order Management
    "ZhuangTai": "สถานะ", // Status
    "ShangPinChuKu": "สินค้าออกจากคลัง", // Goods Outbound
    "DengDaiShouHuo": "รอรับสินค้า", // Awaiting Receipt
    "PeiSongXinXi": "ข้อมูลการจัดส่ง", // Delivery Info
    "FuKuanXinXi": "ข้อมูลการชำระเงิน", // Payment Info
    "GDFKJL": "บันทึกการชำระเงินเพิ่มเติม", // More Payment Records
    "WuLiuFuJian": "ไฟล์แนบการจัดส่ง", // Logistics Attachments
    "ZanWuFuJian": "ไม่มีไฟล์แนบ", // No Attachments
    "YiFa": "ส่งแล้ว", // Sent
    "YingFuZongE": "ยอดชำระรวม", // Total Payable
    "FuKuanShiJian": "เวลาชำระเงิน", // Payment Time
    "ZhangHuHaoMa": "หมายเลขบัญชี", // Account Number
    "KeYongYuE": "ยอดคงเหลือที่ใช้ได้", // Available Balance
    "TianJiaChengGong": "เพิ่มสำเร็จ", // Added Successfully
    "ShanChuDiZhi": "ลบที่อยู่", // Delete Address
    "QXZSHDZ": "กรุณาเลือกที่อยู่จัดส่ง", // Select Shipping Address
    "YiHuoZengPin": "ได้รับของรางวัล", // Gifts Received
    "YiYouHui1Yuan": "ลดไปแล้ว {money}฿", // Saved {money}฿
    "QWSFPXX": "กรุณากรอกข้อมูลใบกำกับ", // Complete Invoice Info
    "1ZSP": "สินค้า {num} ประเภท", // {num} Product Types
    "Gong": "รวม", // Total
    "Jian": "ชิ้น", // Items
    "ShangPinJinE": "ยอดรวมสินค้า", // Product Total
    "YunFeiDaoFu": "เก็บเงินปลายทางค่าจัดส่ง", // Cash on Delivery for Shipping
    "QSRZQDSHRX": "กรุณากรอกชื่อผู้รับที่ถูกต้อง", // Enter Valid Recipient Name
    "QSRZQDXXDZ": "กรุณากรอกที่อยู่เต็มที่ถูกต้อง", // Enter Valid Full Address
    "DBQ_MYZDDY": "ขออภัย ไม่พบหน้าที่ต้องการ", // Sorry, Page Not Found
    "ShouHuoChengGong": "รับสินค้าสำเร็จ", // Receipt Successful
    "Hi_HuanYingNin": "สวัสดี ยินดีต้อนรับ", // Hello, Welcome
    "YiFaEWuLiu": "ส่ง e-Logistics แล้ว", // Shipped via e-Logistics
    "NinDeDingDan": "คำสั่งซื้อของคุณ", // Your Order
    "ZBNBHBQ": "ไม่สามารถใช้อีโมจิได้", // Cannot Use Emojis
    "XMBNWK": "ต้องกรอกชื่อ", // Name Required
    "XiTongSheZhi": "การตั้งค่าระบบ", // System Settings
    "ZhangHaoXinXi": "ข้อมูลบัญชี", // Account Info
    "QingShuRuXingMing": "กรุณากรอกชื่อ", // Enter Name
    "QWSZL_JZYG": "กรอกข้อมูลเพื่อบริการที่ดีขึ้น", // Complete Info for Better Service
    "QSRZQDYXGS": "กรุณากรอกรูปแบบอีเมลที่ถูกต้อง", // Enter Valid Email Format
    "QTXZQDCWXX": "กรุณากรอกข้อมูลการเงินที่ถูกต้อง", // Enter Correct Financial Info
    "GXSHDZCG": "อัปเดตที่อยู่จัดส่งสำเร็จ", // Update Shipping Address Success
    "BCSHDZCG": "บันทึกที่อยู่จัดส่งสำเร็จ", // Save Shipping Address Success
    "XinZengDiZhi": "เพิ่มที่อยู่ใหม่", // Add New Address
    "QXZYQXSCDS": "กรุณาเลือกสินค้าที่จะยกเลิกการติดตาม", // Select Products to Unfavorite
    "QuXiaoShouCang": "ยกเลิกการติดตาม", // Unfavorite
    "XuanZeGuiGe": "เลือกสเปค", // Select Specifications
    "CaiWuGuanLi": "การจัดการการเงิน", // Financial Management
    "DuiZhangMingXi": "รายละเอียดการตรวจสอบ", // Reconciliation Details
    "QSRLWJL_JE": "กรุณากรอกประวัติ/จำนวนเงิน", // Enter Records/Amount
    "YiGouMai1Ci": "ซื้อแล้ว {count} ครั้ง", // Purchased {count} Times
    "6_1GouMai": "ซื้อเมื่อ {time}", // Purchased at {time}
    "TZGGXQ": "รายละเอียดประกาศ", // Notice Details
    "ZYXSCSP": "เฉพาะวิดีโอเท่านั้น", // Only Videos Allowed
    "SCSPDXBYXC": "ขนาดวิดีโอต้องไม่เกิน {size}", // Video Size Limit {size}
    "YDHSP": "สินค้าที่สั่งซื้อแล้ว", // Ordered Products
    "ShangPinPinPai": "แบรนด์สินค้า", // Product Brand
    "ShangPinLieBiao": "รายการสินค้า", // Product List
    "LingShouJia": "ราคาขายปลีก", // Retail Price
    "YouHuiJia": "ราคาพิเศษ", // Special Price
    "LiJiGouMai": "ซื้อทันที", // Buy Now
    "ZhuTu": "ภาพหลัก", // Main Image
    "WuXianZhi": "ไม่จำกัด", // Unlimited
    "XiaoJi": "ยอดรวมย่อย", // Subtotal
    "SCXZSP": "ลบสินค้าที่เลือก", // Delete Selected Products
    "QSRDDH": "กรุณากรอกเลขที่คำสั่งซื้อ", // Enter Order Number
    "QSRDDH_SPMC": "กรุณากรอกเลขที่คำสั่งซื้อ/ชื่อสินค้า", // Enter Order No./Product Name
    "CaoZuo": "การดำเนินการ", // Operation
    "WuLiuXinXi": "ข้อมูลโลจิสติกส์", // Logistics Info
    "CaoZuoLeiXing": "ประเภทการดำเนินการ", // Operation Type
    "CaoZuoRiZhi": "บันทึกการดำเนินการ", // Operation Log
    "CaoZuoShiJian": "เวลาดำเนินการ", // Operation Time
    "ZhangHuMingCheng": "ชื่อบัญชี", // Account Name
    "KaiHuYinHang": "ธนาคาร", // Bank
    "DDTJCG_XZZC": "ส่งคำสั่งซื้อสำเร็จ เหลือเพียงขั้นตอนสุดท้าย", // Order Submitted, Last Step Left
    "ZhiFuJinE": "ยอดชำระ", // Payment Amount
    "DZFJE": "ยอดค้างชำระ", // Pending Payment Amount
    "QTXYXSMB": "กรุณาใส่คำอธิบาย", // Please Add Description
    "XZSKYHZH": "เลือกบัญชีธนาคารรับเงิน", // Select Receiving Bank Account
    "TiShi": "คำเตือน", // Alert
    "NHY1GDDGJ1Y": "คุณมี {num} คำสั่งซื้อ รวม {money}฿", // You Have {num} Orders Totaling {money}฿
    "QKJQHCKJXX": "ชำระหนี้ก่อนสั่งซื้อใหม่", // Settle Debt Before New Order
    "HDDDXX": "ตรวจสอบข้อมูลคำสั่งซื้อ", // Verify Order Info
    "BJSHDZ": "แก้ไขที่อยู่จัดส่ง", // Edit Shipping Address
    "TongZhiGongGao": "ประกาศแจ้งเตือน", // Notification Announcements
    "YinHangZhangHao": "บัญชีธนาคาร", // Bank Account
    "XiuGaiShouJi": "เปลี่ยนหมายเลขโทรศัพท์", // Change Phone Number
    "LXRXX": "ข้อมูลผู้ติดต่อ", // Contact Information
       "GSCWXX": "ข้อมูลการเงินบริษัท", // Company Financial Information
    "QSRKHYHMCJ": "กรุณากรอกชื่อธนาคารและสาขา", // Enter Bank Name and Branch
    "QSRYHZH": "กรุณากรอกหมายเลขบัญชี", // Enter Account Number
    "PiLiangCaoZuo": "ดำเนินการเป็นกลุ่ม", // Batch Operation
    "GouMaiJiLu": "ประวัติการซื้อ", // Purchase History
    "TongZhiBiaoTi": "หัวข้อประกาศ", // Notice Title
    "FaBuShiJian": "เวลาที่เผยแพร่", // Release Time
    "XiaoXiLeiXing": "ประเภทข้อความ", // Message Type
    "XiaoXiNeiRong": "เนื้อหาข้อความ", // Message Content
    "JieShouShiJian": "เวลาที่ได้รับ", // Receive Time
    "QuanBuPinPai": "แบรนด์ทั้งหมด", // All Brands
    "WXSYS_DHGBJ": "สแกนเพื่อสั่งซื้อง่ายๆ", // Scan for Easy Ordering
    "GZWXGZH": "ติดตามบัญชีทางการ", // Follow Official Account
    "FuWuReXian": "สายด่วนบริการ", // Service Hotline
    "SouSuoLiShi": "ประวัติการค้นหา", // Search History
    "QuanBuShanChu": "ลบทั้งหมด", // Delete All
    "NH_HYLDYSDH": "สวัสดี ยินดีต้อนรับสู่ {company}!", // Hello, Welcome to {company}!
    "ZSJDH": "สั่งซื้อผ่านโทรศัพท์", // Order via Phone
    "SYS_GZWXGZH": "สแกนและติดตามบัญชีทางการ", // Scan and Follow Official Account
    "GuanZhuWoMen": "ติดตามเรา", // Follow Us
    "QBSPFL": "หมวดหมู่สินค้าทั้งหมด", // All Product Categories
    "QuPeiDeng": "ไปเลือกโคมไฟ", // Go to Match Lights
    "KuanXiang": "รายการชำระเงิน", // Payment Items
    "QSRSPMC_GG_": "ค้นหาชื่อสินค้า/สเปค/เลขที่/ตัวอักษรแรก", // Search Product Name/Specs/ID/Initial
    "NH_HYLDYSD": "สวัสดี ยินดีต้อนรับสู่ YunShangDingHuo!", // Hello, Welcome to YunShangDingHuo!
    "ReXiao": "ขายดี", // Hot Sales
    "20Tiao_Ye": "20 รายการ/หน้า", // 20 Items/Page
    "ShiChangJia_": "ราคาตลาด:", // Market Price:
    "_134.10Qi": "เริ่มต้นที่ S/134.10", // Starting from S/134.10
    "HJ_BHYF": "ยอดรวม (ไม่รวมค่าจัดส่ง):", // Total (Excl. Delivery):
    "QDSCXZSP_": "ยืนยันลบสินค้าที่เลือก?", // Confirm Delete Selected Products?
    "QDQCXJSP_": "ยืนยันลบสินค้าหมดอายุ?", // Confirm Delete Expired Products?
    "DDTJCG_XZZ": "ส่งคำสั่งซื้อสำเร็จ! เหลือเพียงขั้นตอนสุดท้าย!", // Order Submitted! Last Step Left!
    "XuanZeZhangHu": "เลือกบัญชี", // Select Account
    "DaiZhiFu": "รอการชำระ", // Pending Payment
    "CaiGouDingDan": "คำสั่งซื้อจัดซื้อ", // Purchase Order
    "DingDanXinXi": "ข้อมูลคำสั่งซื้อ", // Order Information
    "TuiChu": "ออก", // Exit
    "KaiHuMingCheng": "ชื่อเจ้าของบัญชี", // Account Holder Name
    "QSRKHMC": "กรุณากรอกชื่อเจ้าของบัญชี", // Enter Account Holder Name
    "_QTXZQDCWX": "(กรุณากรอกข้อมูลการเงินที่ถูกต้องสำหรับการออกใบกำกับ)", // (Provide Accurate Financial Info for Invoicing)
    "ShouHuoRen": "ผู้รับสินค้า", // Receiver
    "SWMRSHDZ": "ตั้งเป็นที่อยู่เริ่มต้น", // Set as Default Address
    "TianJiaDiZhi": "เพิ่มที่อยู่", // Add Address
    "Gong4GeGuiGe": "4 สเปค", // 4 Specifications
    "Zhi": "อัน", // Piece
    "Kuai": "ชิ้น", // Piece
    "Tou": "ตัว", // Head (for animals)
    "Xiang": "กล่อง", // Box
    "Ping": "ขวด", // Bottle
    "KaiShiRiQi": "วันที่เริ่ม", // Start Date
    "JieShuRiQi": "วันที่สิ้นสุด", // End Date
    "YiXuan": "เลือกแล้ว", // Selected
    "ZhiFuZhuangTai": "สถานะการชำระ", // Payment Status
    "QDLCKJG": "กรุณาเข้าสู่ระบบเพื่อดูราคา", // Please Login to View Prices
    "YZMBZQ": "รหัสยืนยันไม่ถูกต้อง", // Incorrect Verification Code
    "ZhiFuJiLu": "บันทึกการชำระ", // Payment Records
    "ShangPinMingCheng": "ชื่อสินค้า", // Product Name
    "DingGouShuLiang": "จำนวนการสั่งซื้อ", // Order Quantity
    "TuiHuoShuLiang": "จำนวนคืน", // Return Quantity
    "QSRTHNR": "กรุณากรอกรายละเอียดการคืน", // Enter Return Details
    "SCTHSM": "อัปโหลดคำอธิบายการคืน", // Upload Return Explanation
    "ShenQingShiJian": "เวลาการขอ", // Application Time
    "ShenQingJinE": "จำนวนเงินที่ขอ", // Applied Amount
    "TuiHuoYuanYin": "สาเหตุการคืน", // Return Reason
    "TuiHuoShuoMing": "คำอธิบายการคืน", // Return Explanation
    "TuiDanHao": "หมายเลขใบคืน", // Return Order Number
    "SXCZ_XDCG": "เครดิตเพียงพอ สั่งซื้อสำเร็จ", // Sufficient Credit, Order Successful
    "SXEDBZ_FKHFH": "เครดิตไม่เพียงพอ ชำระก่อนส่ง", // Insufficient Credit, Pay Before Shipping
    "CGJKZQ_FKFH": "เกินวงเงินเครดิต ชำระก่อนส่ง", // Exceeded Credit Limit, Pay Before Shipping
    "DDTJCG_XZZCZHYB": "ส่งคำสั่งซื้อสำเร็จ! เหลือเพียงขั้นตอนสุดท้าย!", // Order Submitted! Last Step Left!
    "QNZ_NWCFK_FZ": "กรุณาชำระภายใน {time} มิฉะนั้นคำสั่งซื้อจะถูกยกเลิก", // Please Pay Within {time} or Order Cancelled
    "MianFeiLing": "รับฟรี", // Get Free
    "M_KMFLQ_HQ": "ซื้อครบ {target}฿ รับฟรี เหลืออีก {short}฿", // Spend {target}฿ for Free Item, Need {short}฿ More
    "YHDMFSP": "ได้รับสินค้าฟรีแล้ว", // Free Item Received
    "JRMFL": "รับฟรีวันนี้", // Free Today
    "LingGuangLe": "หมดแล้ว", // Out of Stock
    "KeLingQu": "สามารถรับได้", // Available
    "QSRZFJE": "กรุณากรอกยอดชำระ", // Enter Payment Amount
    "QNJKFK_WMJKWNCL": "กรุณาชำระโดยเร็ว เราจะดำเนินการคำสั่งซื้อทันที!", // Please Pay Promptly, We'll Process Your Order!
    "XianXiaTiYanGuan": "แกลเลอรี่ทดลอง", // Experience Gallery
    "QingXuanZheSheng": "กรุณาเลือกจังหวัด", // Select Province
    "QingXuanZheShi": "กรุณาเลือกเมือง", // Select City
    "ZhanGuanDiZhi": "ที่ตั้งแกลเลอรี่", // Gallery Address
    "YingYeShiJian": "เวลาทำการ", // Business Hours
    "ZhanGuanDianHua": "โทรศัพท์แกลเลอรี่", // Gallery Phone
    "FenXiang": "แบ่งปัน", // Share
    "TiYanGuanJieShao": "แนะนำแกลเลอรี่", // Gallery Introduction
    "DPYDY_QSHX": "ร้านปิดแล้ว กรุณาสั่งซื้อภายหลัง", // Shop Closed, Order Later
    "DaYangShiJian": "เวลาปิดร้าน", // Closing Time
    'IMEI': 'หมายเลข IMEI', // IMEI Number
    "FanKuanYuE": "ยอดคืนเงิน", // Rebate Balance
    "FanKuanZhiFu": "ชำระด้วยเงินคืน", // Pay with Rebate
    "YiShengZhiFu": "YiSheng Pay", // YiSheng Pay
    "JiongDongShouYinTai": "Jingdong Cashier", // Jingdong Cashier
    "FKYEBZ": "ยอดคืนเงินไม่เพียงพอ", // Insufficient Rebate Balance
    "FanKuanZhangHu": "บัญชีเงินคืน", // Rebate Account
    "HaiXuZhiFu": "ต้องชำระเพิ่ม {price}", // Need to Pay {price}
    "FaPiaoMingXi": "รายละเอียดใบกำกับ", // Invoice Details
    "FaPiaoZhuShou": "ผู้ช่วยใบกำกับ", // Invoice Assistant
    "WoDeFaPiao": "ใบกำกับของฉัน", // My Invoices
    "FaPiaoXiangQing": "รายละเอียดใบกำกับ", // Invoice Details
    "KaiPiaoShiJian": "เวลาออกใบกำกับ", // Invoice Issuance Time
    "DaiKaiFaPiao": "รอออกใบกำกับ", // Pending Invoice
    "DKFPJE": "ยอดรอออกใบกำกับ", // Pending Invoice Amount
    "KaiPiaoJinE": "ยอดใบกำกับ", // Invoice Amount
    "GuanLianDanHao": "หมายเลขอ้างอิง", // Reference Number
    "ChuangJianShiJian": "เวลาสร้าง", // Creation Time
    "ZhiFuPingZheng": "หลักฐานการชำระ", // Payment Proof
    "QSRZQNR": "กรุณากรอกเนื้อหาที่ถูกต้อง", // Enter Correct Content
    "QSRTDH_SPMC": "กรุณากรอกหมายเลขใบคืน/ชื่อสินค้า", // Enter Return Order No./Product Name
    "ShangPinRuKu": "สินค้าเข้าโกดัง", // Goods Warehouse In
    "TuiKuanChuLi": "ดำเนินการคืนเงิน", // Refund Processing
    "YuanDingDanHao": "หมายเลขคำสั่งซื้อต้นฉบับ", // Original Order Number
    "TuiHuoXinXi": "ข้อมูลการคืนสินค้า", // Return Information
    "TuiKuanXinXi": "ข้อมูลการคืนเงิน", // Refund Information
    "TuiKuanZhuangTai": "สถานะการคืนเงิน", // Refund Status
    "ZWTKJL": "ไม่มีบันทึกการคืนเงิน", // No Refund Records
    "GDTKJL": "บันทึกการคืนเงินเพิ่มเติม", // More Refund Records
    "DDDKFQRBJQSH": "รอการยืนยันราคาจากฝ่ายบริการ", // Pending Price Confirmation from Service
    "BNSRDYHDTSZF": "ห้ามใช้อักขระพิเศษ", // No Special Characters Allowed
    "THSLBNWK": "ต้องกรอกจำนวนคืน", // Return Quantity Required
    "BZBNBHBQ": "หมายเหตุห้ามใช้อีโมจิ", // Notes Cannot Contain Emojis
    "THSLBKDYKTHSL": "จำนวนคืนเกินจำนวนที่คืนได้", // Return Quantity Exceeds Allowed
    "DDM_YZ_J": "สั่งซื้อครบ {target}฿ รับ {number} ชิ้น", // Order Over {target}฿ Get {number} Items
    "M_JZ_J": "ซื้อครบ {target} ชิ้น รับ {number} ชิ้น", // Buy {target} Items Get {number} Items
    "M_JJZ_Y": "ซื้อครบ {target} ชิ้น ในราคา {money}฿", // Buy {target} Items for {money}฿ Each
    "YDHJJZ_Y": "ราคาสั่งซื้อเดิมลดเหลือ {price}฿", // Original Order Price Reduced to {price}฿
    "M_JD_Z": "ซื้อครบ {number} ชิ้น ส่วนลด {percent}%", // Buy {number} Items {percent}% Off
    "YDHJD_Z": "ราคาสั่งซื้อเดิมส่วนลด {percent}%", // Original Order Price {percent}% Off
    "WDSYT": "เคาน์เตอร์ของฉัน", // My Counter
    "ZZSYMPSMJY": "กำลังชำระด้วย Mercado Pago", // Paying with Mercado Pago
    "SKF": "ผู้รับเงิน", // Payee
    "SYSFK": "สแกนเพื่อชำระ", // Scan to Pay
    "DDXQ": "รายละเอียดคำสั่งซื้อ", // Order Details
    "YUAN": "บาท", // Baht (Thai Currency)
    "GXNHQ_Z_Y_": "ยินดีด้วย! คุณได้รับ {num} {price}฿ {name}", // Congratulations! You Got {num} {price}฿ {name}
    "QBLX": "ประเภททั้งหมด", // All Types
    "QLQZX": "ไปที่ศูนย์คูปอง", // Go to Coupon Center
    "YLYH": "ได้รับแล้ว", // Already Received
    "MZTJJKSY": "ใช้งานได้เมื่อตรงตามเงื่อนไข", // Usable When Conditions Met
    "GXNHD_Z_YHQ": "ยินดีด้วย! คุณได้รับ {num} คูปอง", // Congratulations! You Got {num} Coupons
    "G_Y": "รวม {price}฿", // Total {price}฿
    "XZYHQ": "เลือกคูปอง", // Select Coupon
    "PLXD": "สั่งซื้อเป็นกลุ่ม", // Bulk Order
    "FHJL": "บันทึกการจัดส่ง", // Delivery Records
    "DDTJ": "สถิติคำสั่งซื้อ", // Order Statistics
    "DDGL": "การจัดการคำสั่งซื้อ", // Order Management
    "JKWFH": "แสดงที่ยังไม่จัดส่งเท่านั้น", // Show Only Unshipped
    "DDS": "จำนวนคำสั่งซื้อ", // Order Count
    "DGSPS": "จำนวนสินค้าที่สั่งซื้อ", // Ordered Product Quantity
    "THSPS": "จำนวนสินค้าคืน", // Returned Product Quantity
    "YFHSPS": "จำนวนสินค้าที่จัดส่งแล้ว", // Shipped Product Quantity
    "WFHSPS": "จำนวนสินค้ายังไม่จัดส่ง", // Unshipped Product Quantity
    "YFHSPJE": "ยอดสินค้าจัดส่งแล้ว", // Shipped Product Amount
    "WFHSPJE": "ยอดสินค้ายังไม่จัดส่ง", // Unshipped Product Amount
    "WFH": "ยังไม่จัดส่ง", // Not Shipped
    "YGJ": "ราคาโดยประมาณ", // Estimated Price
    "GGBM": "รหัสสเปค", // Specification Code
    "SLHJ": "จำนวนรวม", // Total Quantity
    "JEHJ": "ยอดรวม", // Total Amount
    "QPLKY": "ใช้ได้กับทุกหมวดหมู่", // All Categories Applicable
    "KYCXHDDJSY": "ใช้งานร่วมกับโปรโมชันได้", // Can be Used with Promotions
    "BKDKYF": "ไม่รวมค่าจัดส่ง", // Excluding Shipping
    "SYHBYTH": "ไม่สามารถคืนหลังใช้", // Non-Refundable After Use
    "TiJi": "ปริมาตร", // Volume
    "ZhongLiang": "น้ำหนัก", // Weight
    "ZongTiJi": "ปริมาตรรวม", // Total Volume
    "ZongZhongLiang": "น้ำหนักรวม", // Total Weight
    "QSRDHDCKDWLDHSJRSJH": "ค้นหาเลขที่คำสั่งซื้อ/จัดส่ง/ลอจิสติกส์/ผู้รับ/โทรศัพท์", // Search Order/Delivery/Logistics No./Receiver/Phone
    "CKDH": "เลขที่เอกสารจัดส่ง", // Delivery Note Number
    "WLDZT": "สถานะลอจิสติกส์", // Logistics Status
    "WLDH": "เลขที่ติดตาม", // Tracking Number
    "SJR": "ผู้รับ", // Receiver
};
export default th_TH;
